(function (
  $,
  omit,
  find,
  throttle,
  a11y,
  remove,
  filter,
  fill,
  debounce,
  morphdom2,
  defaultTo,
  findIndex,
  isArray,
  Hammer2
) {
  ($ = "default" in $ ? $.default : $),
    (omit = "default" in omit ? omit.default : omit),
    (find = "default" in find ? find.default : find),
    (throttle = "default" in throttle ? throttle.default : throttle),
    (remove = "default" in remove ? remove.default : remove),
    (filter = "default" in filter ? filter.default : filter),
    (fill = "default" in fill ? fill.default : fill),
    (debounce = "default" in debounce ? debounce.default : debounce),
    (morphdom2 = "default" in morphdom2 ? morphdom2.default : morphdom2),
    (defaultTo = "default" in defaultTo ? defaultTo.default : defaultTo),
    (findIndex = "default" in findIndex ? findIndex.default : findIndex),
    (isArray = "default" in isArray ? isArray.default : isArray),
    (Hammer2 = "default" in Hammer2 ? Hammer2.default : Hammer2);
  function Templates() {
    (this.registered = {}),
      (this.instances = []),
      (this.extensions = { "*": [] });
  }
  Templates.prototype = {
    register: function (name, classname, properties) {
      function Template(container, extensions) {
        (this.name = name.toLowerCase()),
          (this.container = container),
          (this.$container = $(container)),
          (this.extensions = extensions),
          Master.call(this);
      }
      (Template.classname = classname),
        (Template.constructor = Template),
        (Template.prototype = Object.create(Master.prototype)),
        $.extend(Template.prototype, properties),
        (this.registered[name] = Template);
    },
    extend: function (names, extension) {
      names === "*"
        ? ((names = Object.keys(this.registered)), names.push("*"))
        : typeof names == "string" && (names = [names]),
        names.forEach(
          function (name) {
            (this.extensions[name] = this.extensions[name] || []),
              this.extensions[name].push(extension),
              !(typeof this.registered[name] > "u" || name === "*") &&
                this.instances.forEach(function (instance) {
                  instance.name === name && instance.extend(extension);
                });
          }.bind(this)
        );
    },
    load: function (names) {
      names === "*"
        ? (names = Object.keys(this.registered))
        : typeof names == "string" && (names = [names]),
        names.forEach(this._loadTemplate.bind(this));
    },
    _loadTemplate: function (name) {
      var Template = this.registered[name],
        instance = find(this.instances, { name }),
        container,
        extensions;
      typeof Template > "u" ||
        instance ||
        (Template.classname === "*"
          ? (container = document.body)
          : (container = document.querySelector("body." + Template.classname)),
        container &&
          ((extensions = this.extensions["*"].concat(
            this.extensions[name] || []
          )),
          (instance = new Template(container, extensions)),
          $.isFunction(instance.onLoad) && instance.onLoad(container),
          this.instances.push(instance)));
    },
  };
  function Master() {
    this.extensions.forEach(
      function (extension) {
        this.extend(extension);
      }.bind(this)
    );
  }
  Master.prototype = {
    extend: function (extension) {
      var init = extension.init;
      this.extensions.push(extension),
        $.isFunction(init) && (extension = omit(extension, "init")),
        $.extend(this, extension),
        init.apply(this);
    },
  };
  var templates = new Templates(),
    classes$1 = { disableScroll: "disable-scroll", isTouch: "is-touch" },
    utils = {
      pointerEventToXY: function (event) {
        var position;
        return (
          event.originalEvent.touches
            ? (position =
                event.originalEvent.touches[0] ||
                event.originalEvent.changedTouches[0])
            : (position = event),
          { x: position.pageX, y: position.pageY }
        );
      },
      promiseRepeatSeries: function (promise, count) {
        return (
          count--,
          promise().then(
            function () {
              if (count) return this.promiseRepeatSeries(promise, count);
            }.bind(this)
          )
        );
      },
      mapPromiseSeries: function (iterable, cb, delay) {
        var series = $.Deferred().resolve();
        $.each(iterable, function (index, item) {
          series = series.then(function () {
            return typeof delay == "number"
              ? delayedReturn(index, item)
              : cb(index, item);
          });
        });
        function delayedReturn(index, item) {
          return $.Deferred(function (defer) {
            setTimeout(function () {
              defer.resolve(cb(index, item));
            }, delay);
          });
        }
        return series;
      },
      promiseAnimationEnd: function ($el) {
        var events2 = "animationend webkitAnimationEnd oAnimationEnd",
          properties = [
            "animation-duration",
            "-moz-animation-duration",
            "-webkit-animation-duration",
            "-o-animation-duration",
          ],
          duration = 0,
          promise = $.Deferred().resolve();
        return (
          $.each(properties, function (index, value) {
            duration || (duration = parseFloat($el.css(value)));
          }),
          duration > 0 &&
            (promise = $.Deferred(function (defer) {
              $el.on(events2, function (evt) {
                evt.target === $el[0] && ($el.off(events2), defer.resolve());
              });
            })),
          promise
        );
      },
      promiseTransitionEnd: function ($el) {
        var events2 =
            "webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend",
          properties = [
            "transition-duration",
            "-moz-transition-duration",
            "-webkit-transition-duration",
            "-o-transition-duration",
          ],
          duration = 0,
          promise = $.Deferred().resolve();
        return (
          $.each(properties, function (index, value) {
            duration || (duration = parseFloat($el.css(value)));
          }),
          duration > 0 &&
            (promise = $.Deferred(function (defer) {
              $el.on(events2, function (evt) {
                evt.target === $el[0] && ($el.off(events2), defer.resolve());
              });
            })),
          promise
        );
      },
      isLocalStorageSupported: function () {
        var mod = "localStorageTest";
        try {
          return (
            localStorage.setItem(mod, mod), localStorage.removeItem(mod), !0
          );
        } catch {
          return !1;
        }
      },
      isSessionStorageSupported: function () {
        var mod = "sessionStorageTest";
        try {
          return (
            sessionStorage.setItem(mod, mod), sessionStorage.removeItem(mod), !0
          );
        } catch {
          return !1;
        }
      },
      disableTabbingOfChildren: function (containers) {
        $(containers).each(function (index, container) {
          $(
            "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]",
            container
          ).attr("tabindex", "-1");
        });
      },
      enableTabbingOfChildren: function (containers) {
        $(containers).each(function (index, container) {
          $(
            "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex]:not(.plyr):not([data-product-media-wrapper]), *[contenteditable]",
            container
          ).removeAttr("tabindex");
        });
      },
      isiOSSafari: function () {
        var userAgent = window.navigator.userAgent,
          iOS = !!userAgent.match(/iPad/i) || !!userAgent.match(/iPhone/i),
          webkit = !!userAgent.match(/WebKit/i);
        return iOS && webkit && !userAgent.match(/CriOS/i);
      },
      disableScrollBody: function () {
        document.body.scrollHeight - window.innerHeight !== 0 &&
          $("html").addClass(classes$1.disableScroll);
      },
      enableScrollBody: function () {
        $("html").removeClass(classes$1.disableScroll);
      },
      updateUrlParameter: function (url, key, value) {
        var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i"),
          separator = url.indexOf("?") === -1 ? "?" : "&";
        return url.match(re)
          ? url.replace(re, "$1" + key + "=" + value + "$2")
          : url + separator + key + "=" + value;
      },
      cookiesEnabled: function () {
        var cookieEnabled = navigator.cookieEnabled;
        return (
          cookieEnabled ||
            ((document.cookie = "testcookie"),
            (cookieEnabled = document.cookie.indexOf("testcookie") !== -1)),
          cookieEnabled
        );
      },
      onFirst: function (name, fn) {
        this.on(name, fn),
          this.each(function () {
            var handlers = $._data(this, "events")[name.split(".")[0]],
              handler = handlers.pop();
            handlers.splice(0, 0, handler);
          });
      },
      promiseStylesheet: function (stylesheet) {
        var stylesheetUrl = stylesheet || theme.stylesheet;
        return (
          typeof this.stylesheetPromise > "u" &&
            (this.stylesheetPromise = $.Deferred(function (defer) {
              var link = document.querySelector(
                'link[href="' + stylesheetUrl + '"]'
              );
              link.loaded && defer.resolve(),
                onloadCSS(link, function () {
                  defer.resolve();
                });
            })),
          this.stylesheetPromise
        );
      },
      isMobile: function () {
        var status2 = !1;
        this.isMobile = function () {
          return status2;
        };
        function checkIfMobile() {
          return (
            (status2 = $(window).outerWidth() < theme.mediaQuerySmall), status2
          );
        }
        return (
          ($.fn.onFirst = this.onFirst),
          $(window).onFirst("resize", checkIfMobile),
          checkIfMobile()
        );
      },
      isTablet: function () {
        var status2 = !1;
        this.isTablet = function () {
          return status2;
        };
        function checkIfTablet() {
          var width = $(window).outerWidth();
          return (
            (status2 =
              width > theme.mediaQuerySmall && width < theme.mediaQueryMedium),
            status2
          );
        }
        return (
          ($.fn.onFirst = this.onFirst),
          $(window).onFirst("resize", checkIfTablet),
          checkIfTablet()
        );
      },
      isInOrAboveViewport: function (element) {
        var rect = element.getBoundingClientRect(),
          offset = 50;
        return (
          (rect.top + offset >= 0 && rect.top + offset <= window.innerHeight) ||
          (rect.bottom + offset >= 0 &&
            rect.bottom + offset <= window.innerHeight) ||
          (rect.top + offset < 0 &&
            rect.bottom + offset > window.innerHeight) ||
          rect.bottom < 0
        );
      },
      isTouch: function () {
        var status2 = !1;
        return (
          (this.isTouch = function () {
            return status2;
          }),
          $(document).one("touchstart", function () {
            (status2 = !0), $("html").addClass(classes$1.isTouch);
          }),
          status2
        );
      },
      keyboardKeys: {
        TAB: 9,
        ENTER: 13,
        SPACE: 32,
        LEFTARROW: 37,
        RIGHTARROW: 39,
      },
    },
    selectors = { elementsToAnimate: "[data-animate]" },
    classes = {
      animated: "has-animated",
      animationsDisabled: "animations--disabled",
    };
  templates.register("Page animations", "*", {
    onLoad: function () {
      if (
        ((this.animationNamespace = ".animations"),
        (this.$elementsToAnimate = $(
          selectors.elementsToAnimate,
          this.$container
        )),
        this.$elementsToAnimate.length !== 0)
      ) {
        var scrollEvent = "scroll" + this.animationNamespace;
        Shopify.designMode &&
          (scrollEvent += " touchmove" + this.animationNamespace),
          $(window).on(
            scrollEvent,
            throttle(this._animateElementsInViewport.bind(this), 200)
          ),
          $(window).on(
            "resize" + this.animationNamespace,
            throttle(this._animateElementsInViewport.bind(this), 200)
          ),
          Shopify &&
            Shopify.designMode &&
            ($(document).on(
              "shopify:section:load shopify:section:select",
              this._onSectionSelect.bind(this)
            ),
            $(document).on(
              "shopify:section:unload shopify:section:deselect",
              this._onSectionDeselect.bind(this)
            )),
          utils
            .promiseStylesheet()
            .then(this._animateElementsInViewport.bind(this));
      }
    },
    _animateElementsInViewport: function () {
      (this.$elementsToAnimate = this.$elementsToAnimate.map(function (
        index,
        element
      ) {
        return utils.isInOrAboveViewport(element)
          ? (requestAnimationFrame(function () {
              $(element).addClass(classes.animated),
                $(element).trigger("animate_element", [element]);
            }),
            null)
          : element;
      })),
        this.$elementsToAnimate.length === 0 &&
          $(window).off(this.animationNamespace);
    },
    _onSectionSelect: function () {
      $(document.body).addClass(classes.animationsDisabled);
    },
    _onSectionDeselect: function (evt) {
      $(document.body).removeClass(classes.animationsDisabled),
        $(evt.target)
          .find(selectors.elementsToAnimate)
          .addClass(classes.animated);
    },
  });
  var selectors$2 = {
      socialSharing: ".social-sharing",
      socialSharingToggle: ".social-sharing__toggle",
      linkList: ".social-sharing__item-list",
    },
    classes$3 = { socialSharingAction: "social-sharing--active" },
    socialSharing = {
      init: function () {
        (this.$elements = $(selectors$2.socialSharing, this.$container)),
          (this.clicked = !1),
          $(selectors$2.socialSharingToggle, this.$container)
            .on("click", this._onClick.bind(this))
            .one("click", function () {
              this.clicked = !0;
            }),
          this.$container.on(
            "section_unload",
            this.destroySocialSharing.bind(this)
          );
      },
      showSocialSharing: function () {
        $(selectors$2.socialSharing, this.$container).addClass(
          classes$3.socialSharingAction
        ),
          $(selectors$2.socialSharingToggle, this.$container).attr(
            "aria-expanded",
            !0
          ),
          $(selectors$2.linkList, this.$container).attr("aria-hidden", !1),
          utils.enableTabbingOfChildren(
            $(selectors$2.linkList, this.$container)
          );
      },
      hideSocialSharing: function () {
        $(selectors$2.socialSharing, this.$container).removeClass(
          classes$3.socialSharingAction
        ),
          $(selectors$2.socialSharingToggle, this.$container).attr(
            "aria-expanded",
            !1
          ),
          $(selectors$2.linkList, this.$container).attr("aria-hidden", !0),
          utils.disableTabbingOfChildren(
            $(selectors$2.linkList, this.$container)
          );
      },
      destroySocialSharing: function () {
        $(selectors$2.socialSharingToggle, this.$container).off();
      },
      _onClick: function (evt) {
        $(evt.currentTarget).attr("aria-expanded") === "true"
          ? this.hideSocialSharing()
          : this.showSocialSharing();
      },
    },
    selectors$1 = {
      articleContentWrapper: ".article__wrapper",
      articleShareDesktop: ".article__share-desktop",
      articleShareMobile: ".article__share-mobile",
      articleShareDesktopWrapper: ".article__share-desktop-wrapper",
      socialSharing: ".social-sharing",
    },
    classes$2 = {
      shareFixed: "article__share-desktop--fixed",
      shareBottom: "article__share-desktop--bottom",
    },
    settings = { shareExpandedHeight: 350 };
  templates.register("Article Template", "template-article", {
    onLoad: function () {
      this.extend(socialSharing),
        $(window)
          .on("scroll", this.setSharePosition.bind(this))
          .on("resize", this.updateMeasurements.bind(this)),
        utils.promiseStylesheet().then(
          function () {
            this.updateMeasurements();
          }.bind(this)
        );
    },
    setSharePosition: function () {
      if (!(utils.isMobile() || utils.isTablet())) {
        var scrollTop = $(window).scrollTop();
        requestAnimationFrame(
          function () {
            scrollTop > this.fixedTop
              ? scrollTop > this.fixedBottom
                ? $(selectors$1.articleShareDesktop)
                    .removeClass(classes$2.shareFixed)
                    .addClass(classes$2.shareBottom)
                : $(selectors$1.articleShareDesktop)
                    .addClass(classes$2.shareFixed)
                    .removeClass(classes$2.shareBottom)
              : $(selectors$1.articleShareDesktop)
                  .removeClass(classes$2.shareFixed)
                  .removeClass(classes$2.shareBottom),
              this.clicked ||
                (scrollTop > this.fixedBottom - settings.shareExpandedHeight
                  ? this.showSocialSharing()
                  : this.hideSocialSharing());
          }.bind(this)
        );
      }
    },
    updateMeasurements: function () {
      (this.fixedTop = $(selectors$1.articleContentWrapper).offset().top),
        (this.fixedBottom =
          this.fixedTop +
          $(selectors$1.articleContentWrapper).height() -
          $(selectors$1.articleShareDesktopWrapper).height()),
        (this.windowHeight = $(window).outerHeight()),
        this.setSharePosition();
    },
  });
  var selectors$3 = {
      addressCountrySelect: ".address-country-selector",
      newToggle: ".address-new-toggle",
      newAddressContainer: ".new-address",
      editToggle: ".address-edit-toggle",
      editAddressContainer: ".edit-address",
      editAddressContainerId: "#EditAddress_",
      deleteAddress: ".address-delete",
      currentAddresses: ".current-addresses",
      currentAddress: "#CurrentAddress_",
      currentAddressesItem: ".current-addresses__item",
    },
    classes$4 = {
      newAddressHide: "new-address--hidden",
      editAddressShow: "edit-address--show",
    };
  templates.register(
    "Customer Addresses Template",
    "template-customers-addresses",
    {
      onLoad: function (container) {
        var $container = (this.$container = $(container)),
          $countryOptions = $(theme.countryOptionTags).filter("option"),
          $addressCountrySelect = $(
            selectors$3.addressCountrySelect,
            $container
          ),
          $newAddressContainer = $(selectors$3.newAddressContainer, $container),
          $editAddressContainers = $(
            selectors$3.editAddressContainer,
            $container
          );
        $addressCountrySelect.each(
          function (index, countrySelect) {
            var $countrySelect = this._populateCountrySelect(
                countrySelect,
                $countryOptions
              ),
              currentProvinces = this._fetchCurrentProvinces($countrySelect),
              $provinceSelect = $(
                $countrySelect.attr("data-province-select"),
                $container
              ),
              defaultProvince = $provinceSelect.data("default");
            this._populateProvinceSelect(
              $provinceSelect,
              currentProvinces,
              defaultProvince
            );
          }.bind(this)
        ),
          $(selectors$3.newToggle).on(
            "click",
            this._onNewAddressClick.bind(this)
          ),
          $(selectors$3.editToggle).on(
            "click",
            this._onEditAddressClick.bind(this)
          ),
          $(selectors$3.deleteAddress).on(
            "click",
            this._onDeleteAddressClick.bind(this)
          ),
          $("div.errors", $newAddressContainer).length !== 0 &&
            $newAddressContainer.removeClass(classes$4.newAddressHide),
          $editAddressContainers.each(function () {
            $("div.errors", this).length !== 0 &&
              $(this).addClass(classes$4.editAddressShow);
          });
      },
      _populateCountrySelect: function (countrySelect, countryOptions) {
        var $countrySelect = $(countrySelect),
          defaultValue = $countrySelect.data("default"),
          defaultOption = countryOptions[0];
        return (
          typeof defaultValue == "string" &&
            defaultValue !== "" &&
            (defaultOption = find(countryOptions, function (el) {
              return el.text === defaultValue;
            })),
          $countrySelect
            .html(countryOptions.clone())
            .val(defaultOption.value)
            .on("change", this._onCountrySelectChange.bind(this))
        );
      },
      _populateProvinceSelect: function (
        $provinceSelect,
        provinces,
        defaultValue
      ) {
        var $container = $provinceSelect.parent(),
          provinceOptions = provinces.map(this._createProvinceOption),
          value = defaultValue || $(provinceOptions[0]).val();
        return (
          provinceOptions.length ? $container.show() : $container.hide(),
          $provinceSelect.html(provinceOptions).val(value)
        );
      },
      _createProvinceOption: function (province) {
        return $("<option>").attr({ value: province[1] }).text(province[1]);
      },
      _fetchCurrentProvinces: function ($countrySelect) {
        return $countrySelect.find(":selected").data("provinces") || [];
      },
      _onCountrySelectChange: function (event) {
        var $countrySelect = $(event.target),
          currentProvinces = this._fetchCurrentProvinces($countrySelect),
          $provinceSelect = $($countrySelect.data("province-select"));
        this._populateProvinceSelect($provinceSelect, currentProvinces);
      },
      _onNewAddressClick: function () {
        $(selectors$3.newAddressContainer, this.$container).toggleClass(
          classes$4.newAddressHide
        );
      },
      _onEditAddressClick: function (event) {
        var formId = $(event.target).data("form-id");
        $(
          selectors$3.editAddressContainerId + formId,
          this.$container
        ).toggleClass(classes$4.editAddressShow);
      },
      _onDeleteAddressClick: function (event) {
        var $button = $(event.target),
          formId = $button.data("form-id"),
          addressUrl = $button.data("address-url"),
          confirmMessage = $button.data("confirm-message"),
          $container = $(selectors$3.currentAddress + formId, this.$container);
        confirm(confirmMessage) &&
          ($.post(addressUrl, { _method: "delete" }),
          $container.remove(),
          $(selectors$3.currentAddressesItem).length ||
            ($(selectors$3.currentAddresses, this.$container).remove(),
            $(selectors$3.newAddressContainer, this.$container).removeClass(
              classes$4.newAddressHide
            )));
      },
    }
  );
  var selectors$4 = {
    recoverPasswordForm: "#RecoverPasswordForm",
    customerLoginForm: "#CustomerLoginForm",
    hideRecoverPasswordLink: "#HideRecoverPasswordLink",
    showRecoverPasswordLink: "#RecoverPassword",
  };
  templates.register("Customer Login Template", "template-customers-login", {
    onLoad: function (container) {
      var $container = (this.$container = $(container));
      this.checkUrlHash(),
        this.resetPasswordSuccess(),
        $(selectors$4.showRecoverPasswordLink, $container).on(
          "click",
          this.onShowHidePasswordForm.bind(this)
        ),
        $(selectors$4.hideRecoverPasswordLink, $container).on(
          "click",
          this.onShowHidePasswordForm.bind(this)
        );
    },
    onShowHidePasswordForm: function (evt) {
      evt.preventDefault(), this.toggleRecoverPasswordForm();
    },
    checkUrlHash: function () {
      var hash = window.location.hash;
      hash === "#recover" && this.toggleRecoverPasswordForm();
    },
    toggleRecoverPasswordForm: function () {
      $(selectors$4.recoverPasswordForm).toggleClass("hide"),
        $(selectors$4.customerLoginForm).toggleClass("hide");
    },
    resetPasswordSuccess: function () {
      $(".reset-password-success").length &&
        $("#ResetSuccess").removeClass("hide");
    },
  }),
    Element.prototype.matches ||
      (Element.prototype.matches =
        Element.prototype.matchesSelector ||
        Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector);
  var rte = {
    wrapTable: function () {
      $(".rte table").wrap('<div class="rte__table-wrapper"></div>');
    },
    iframeReset: function () {
      var $iframeVideo = $(
          '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'
        ),
        $iframeReset = $iframeVideo.add(".rte iframe#admin_bar_iframe");
      $iframeVideo.each(function () {
        $(this).wrap('<div class="video-wrapper"></div>');
      }),
        $iframeReset.each(function () {
          this.src = this.src;
        });
    },
    imageLink: function () {
      $(".rte a:has(img)").addClass("image-link");
    },
  };
  templates.register("Page Helpers", "*", {
    onLoad: function () {
      this.pageLinkFocus(),
        this.rteFixes(),
        this.disableOutlineOnClick(),
        this.checkIfMobileOS();
    },
    pageLinkFocus: function () {
      a11y.focusHash({ className: "js-focus-hidden" }),
        a11y.bindInPageLinks({
          className: "js-focus-hidden",
          ignore: "[data-link-no-focus]",
        });
    },
    rteFixes: function () {
      rte.wrapTable(), rte.iframeReset(), rte.imageLink();
    },
    disableOutlineOnClick: function () {
      var classes2 = { outlineDisabled: "outline-disabled" };
      $("html").addClass(classes2.outlineDisabled),
        $(document).on("keyup", function () {
          $("html").removeClass(classes2.outlineDisabled);
        }),
        $(document).on("click", function (evt) {
          $("html").toggleClass(
            classes2.outlineDisabled,
            !$(evt.target).is("input, textarea, select, button")
          );
        });
    },
    checkIfMobileOS: function () {
      var ua = navigator.userAgent.toLowerCase(),
        isIOS = /ipad|iphone|ipod/.test(ua) && !window.MSStream,
        isAndroid = /android/.test(ua);
      isIOS && $("html").addClass("is-mobile-os").addClass("is-ios"),
        isAndroid && $("html").addClass("is-mobile-os").addClass("is-android");
    },
  });
  var a11y$1 = {
    pageLinkFocus: function ($element) {
      var focusClass = "js-focus-hidden";
      $element
        .first()
        .attr("tabIndex", "-1")
        .focus()
        .addClass(focusClass)
        .one("blur", callback);
      function callback() {
        $element.first().removeClass(focusClass).removeAttr("tabindex");
      }
    },
    forceFocus: function ($element) {
      $element.focus(),
        $element.is(document.activeElement) ||
          $element
            .attr("tabindex", "0")
            .focus()
            .one("blur", function () {
              $element.removeAttr("tabindex");
            });
    },
    focusHash: function () {
      var hash = window.location.hash;
      hash &&
        document.getElementById(hash.slice(1)) &&
        this.pageLinkFocus($(hash));
    },
    bindInPageLinks: function () {
      $("a[href*=#]").on(
        "click",
        function (evt) {
          this.pageLinkFocus($(evt.currentTarget.hash));
        }.bind(this)
      );
    },
    trapFocus: function (options) {
      var eventName = options.namespace
        ? "focusin." + options.namespace
        : "focusin";
      options.$elementToFocus || (options.$elementToFocus = options.$container),
        options.$container.attr("tabindex", "-1"),
        options.$elementToFocus.focus(),
        $(document).on(eventName, function (evt) {
          options.$container[0] !== evt.target &&
            !options.$container.has(evt.target).length &&
            options.$container.focus();
        });
    },
    removeTrapFocus: function (options) {
      var eventName = options.namespace
        ? "focusin." + options.namespace
        : "focusin";
      options.$container &&
        options.$container.length &&
        options.$container.removeAttr("tabindex"),
        $(document).off(eventName);
    },
  };
  $.fn.prepareTransition = function () {
    return this.each(function () {
      var el = $(this);
      el.one(
        "TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",
        function () {
          el.removeClass("is-transitioning");
        }
      );
      var cl = [
          "transition-duration",
          "-moz-transition-duration",
          "-webkit-transition-duration",
          "-o-transition-duration",
        ],
        duration = 0;
      $.each(cl, function (idx, itm) {
        duration || (duration = parseFloat(el.css(itm)));
      }),
        duration != 0 && (el.addClass("is-transitioning"), el[0].offsetWidth);
    });
  };
  var selectors$5 = {
      passwordModal: ".password-modal",
      modalOpenButton: ".password__open-modal",
      modalCloseButton: ".password-modal__close",
      modalInput: ".password-modal__input",
    },
    classes$5 = {
      passwordModalOpen: "password-modal--open",
      disableScroll: "disable-scroll",
    };
  templates.register("Password Template", "password-template", {
    onLoad: function (container) {
      var $container = (this.$container = $(container));
      $(selectors$5.modalOpenButton, $container).on(
        "click",
        this.showPasswordModal.bind(this)
      ),
        $(selectors$5.modalCloseButton, $container).on(
          "click",
          this.hidePasswordModal.bind(this)
        ),
        $(".errors", $container).length && this.showPasswordModal();
    },
    showPasswordModal: function () {
      var $container = this.$container,
        $modal = $(selectors$5.passwordModal, $container);
      a11y$1.trapFocus({
        $container: $modal,
        namespace: "passwordModal",
        $elementToFocus: $(selectors$5.modalCloseButton, $container),
      }),
        $modal.prepareTransition().addClass(classes$5.passwordModalOpen),
        $(selectors$5.modalOpenButton, $container).attr("aria-expanded", !0),
        $(selectors$5.modalInput, $container).focus(),
        $(document.documentElement).addClass(classes$5.disableScroll),
        $(document).on("keyup", this.closeOnEscape.bind(this));
    },
    hidePasswordModal: function () {
      var $container = this.$container,
        $modal = $(selectors$5.passwordModal, $container);
      a11y$1.removeTrapFocus({ namespace: "passwordModal" }),
        $modal.prepareTransition().removeClass(classes$5.passwordModalOpen),
        $(document.documentElement).removeClass(classes$5.disableScroll),
        $(selectors$5.modalOpenButton, $container)
          .attr("aria-expanded", !1)
          .focus(),
        $(document).off("keyup", this.closeOnEscape.bind(this));
    },
    closeOnEscape: function (evt) {
      evt.keyCode === 27 && this.hidePasswordModal();
    },
  });
  function Sections() {
    (this.$document = $(document)),
      (this.namespace = ".section-js-events"),
      document.addEventListener(
        "shopify:section:load",
        function (evt) {
          var id = evt.detail.sectionId,
            container = evt.target.querySelector(
              '[data-section-id="' + id + '"]'
            ),
            type = container.getAttribute("data-section-type");
          this.load(type, container);
        }.bind(this)
      );
  }
  $.extend(Sections.prototype, {
    registered: {},
    instances: [],
    extensions: { "*": [] },
    register: function (type, properties) {
      function Section(data2) {
        (this.type = type), Master$1.call(this, data2);
      }
      (Section.constructor = this.registered[type]),
        (Section.prototype = Object.create(Master$1.prototype)),
        $.extend(Section.prototype, properties),
        (this.registered[type] = Section);
    },
    load: function (types2, containers) {
      (types2 = this._normalizeTypeParam(types2)),
        (containers = this._normalizeContainersParam(containers)),
        types2.forEach(
          function (type) {
            var Section = this.registered[type],
              selection = containers;
            typeof Section > "u" ||
              (typeof selection > "u" &&
                (selection = document.querySelectorAll(
                  '[data-section-type="' + type + '"]'
                )),
              (selection = Array.prototype.slice.call(selection)),
              selection.forEach(
                function (container) {
                  if (!this._instanceExists(container)) {
                    var extensions = this.extensions["*"].concat(
                        this.extensions[type] || []
                      ),
                      instance = new Section({
                        container,
                        extensions,
                        id: container.getAttribute("data-section-id"),
                      });
                    instance.trigger("section_load"),
                      this.instances.push(instance);
                  }
                }.bind(this)
              ));
          }.bind(this)
        );
    },
    extend: function (types2, extension) {
      (types2 = this._normalizeTypeParam(types2)),
        types2.forEach(
          function (type) {
            (this.extensions[type] = this.extensions[type] || []),
              this.extensions[type].push(extension),
              !(typeof this.registered[type] > "u") &&
                this.instances.forEach(function (instance) {
                  instance.type === type && instance.extend(extension);
                });
          }.bind(this)
        );
    },
    isInstance: function (type) {
      return typeof find(this.instances, { type }) == "object";
    },
    getInstances: function (type) {
      return $.Deferred(
        function (defer) {
          var instances = filter(this.instances, { type });
          instances.length === 0 ? defer.reject() : defer.resolve(instances);
        }.bind(this)
      );
    },
    on: function () {
      var args = Array.prototype.slice.call(arguments);
      (args[0] = args[0].concat(this.namespace)),
        this.$document.on.apply(this.$document, args);
    },
    off: function () {
      var args = Array.prototype.slice.call(arguments);
      (args[0] = args[0].concat(this.namespace)),
        this.$document.off.apply(this.$document, arguments);
    },
    trigger: function () {
      var triggerArgs = arguments;
      this.instances.forEach(function (instance) {
        instance.trigger.apply(instance, triggerArgs);
      });
    },
    _sectionTrigger: function () {
      this.$document.trigger.apply(this.$document, arguments);
    },
    _normalizeTypeParam: function (types2) {
      return (
        types2 === "*"
          ? (types2 = Object.keys(this.registered))
          : typeof types2 == "string" && (types2 = [types2]),
        (types2 = types2.map(function (type) {
          return type.toLowerCase();
        })),
        types2
      );
    },
    _normalizeContainersParam: function (containers) {
      return (
        !Array.isArray(containers) &&
          typeof containers == "object" &&
          (containers = [containers]),
        containers
      );
    },
    _instanceExists: function (container) {
      var instance = find(this.instances, {
        id: container.getAttribute("data-section-id"),
      });
      return typeof instance < "u";
    },
  });
  var sections = new Sections();
  function Master$1(data2) {
    (this.container = data2.container),
      (this.$container = $(this.container)),
      (this.id = data2.id),
      (this.namespace = "." + data2.id),
      (this.extensions = data2.extensions || []),
      (this.$eventBinder = this.$container),
      _applyExtensions.call(this),
      _applyEditorHandlers.call(this),
      _applyDefaultHandlers.call(this);
  }
  (Master$1.prototype = {
    onLoad: function () {},
    onUnload: function () {},
    onSelect: function () {},
    onDeselect: function () {},
    onBlockSelect: function () {},
    onBlockDeselect: function () {},
    on: function () {
      var args = Array.prototype.slice.call(arguments);
      (args[0] = args[0].concat(this.namespace)),
        this.$eventBinder.on.apply(this.$eventBinder, args),
        (this.$eventBinder = this.$container);
    },
    one: function () {
      var args = Array.prototype.slice.call(arguments);
      (args[0] = args[0].concat(this.namespace)),
        this.$eventBinder.one.apply(this.$eventBinder, args),
        (this.$eventBinder = this.$container);
    },
    off: function () {
      var args = Array.prototype.slice.call(arguments);
      (args[0] = args[0] || ""),
        (args[0] = args[0].concat(this.namespace)),
        this.$eventBinder.off.apply(this.$eventBinder, arguments),
        (this.$eventBinder = this.$container);
    },
    trigger: function () {
      var args = Array.prototype.slice.call(arguments);
      (args[1] = args[1] || []),
        args[1].splice(0, 0, this),
        this.$eventBinder.trigger.apply(this.$eventBinder, args),
        (this.$eventBinder = this.$container);
    },
    extend: function (extension) {
      var init = extension.init;
      this.extensions.push(extension),
        $.extend(this, omit(extension, "init")),
        $.isFunction(init) && init.apply(this);
    },
  }),
    (Master$1.prototype.document = function () {
      var $document = $(document),
        self = this;
      return {
        on: function () {
          (self.$eventBinder = $document), self.on.apply(self, arguments);
        },
        off: function () {
          (self.$eventBinder = $document), self.off.apply(self, arguments);
        },
        trigger: function () {
          (self.$eventBinder = $document), self.trigger.apply(self, arguments);
        },
      };
    }),
    (Master$1.prototype.window = function () {
      var $window = $(window),
        self = this;
      return {
        on: function () {
          (self.$eventBinder = $window), self.on.apply(self, arguments);
        },
        off: function () {
          (self.$eventBinder = $window), self.off.apply(self, arguments);
        },
        trigger: function () {
          (self.$eventBinder = $window), self.trigger.apply(self, arguments);
        },
      };
    });
  function _applyExtensions() {
    this.extensions.forEach(
      function (extension) {
        this.extend(extension);
      }.bind(this)
    );
  }
  function _applyEditorHandlers() {
    $(document)
      .on(
        "shopify:section:unload" + this.namespace,
        _onSectionUnload.bind(this)
      )
      .on("shopify:section:select" + this.namespace, _onSelect.bind(this))
      .on("shopify:section:deselect" + this.namespace, _onDeselect.bind(this))
      .on("shopify:block:select" + this.namespace, _onBlockSelect.bind(this))
      .on(
        "shopify:block:deselect" + this.namespace,
        _onBlockDeselect.bind(this)
      );
  }
  function _applyDefaultHandlers() {
    this.on("section_load", this.onLoad.bind(this)),
      this.on("section_unload", this.onUnload.bind(this)),
      this.on("section_select", this.onSelect.bind(this)),
      this.on("section_deselect", this.onDeselect.bind(this)),
      this.on("block_select", this.onBlockSelect.bind(this)),
      this.on("block_deselect", this.onBlockDeselect.bind(this));
  }
  function _onSectionUnload(event) {
    this.id === event.detail.sectionId &&
      ((event.type = "section_unload"),
      this.trigger(event),
      this.off(this.namespace),
      sections.off(this.namespace),
      $(document).off(this.namespace),
      $(window).off(this.namespace),
      remove(sections.instances, { id: this.id }));
  }
  function _onSelect(event) {
    this.id === event.detail.sectionId &&
      ((event.type = "section_select"), this.trigger(event));
  }
  function _onDeselect(event) {
    this.id === event.detail.sectionId &&
      ((event.type = "section_deselect"), this.trigger(event));
  }
  function _onBlockSelect(event) {
    this.id === event.detail.sectionId &&
      ((event.type = "block_select"), this.trigger(event));
  }
  function _onBlockDeselect(event) {
    this.id === event.detail.sectionId &&
      ((event.type = "block_deselect"), this.trigger(event));
  }
  var classes$6 = {
      cardListSubLoaded: "card-list__sub-actions--loaded",
      cardReveal: "card--reveal",
      searchTemplate: "template-search",
    },
    selectors$6 = {
      cardList: ".card-list",
      cardListColumn: ".card-list__column",
      cardListSub: ".card-list__sub-actions",
      card: ".card",
      cardWrapper: ".card__wrapper",
      cardInfo: ".card__info",
    },
    cardManager = {
      init: function () {
        (this.$cardList = $(selectors$6.cardList, this.$container)),
          (this.$emptyColumn = $(selectors$6.cardListColumn, this.$container)
            .clone()
            .empty()),
          (this.$cards = $(selectors$6.card, this.$container)),
          (this.desktopColumnCount =
            this.$cardList.data("desktop-columns") || 1),
          (this.mobileColumnCount = this.$cardList.data("mobile-columns") || 1),
          (this.columnCount = utils.isMobile()
            ? this.mobileColumnCount
            : this.desktopColumnCount),
          (this.gridStyle = this.$cardList.data("grid-style") || "collage"),
          (this.windowWidth = $(window).outerWidth()),
          (this.cardLoadPromises = []),
          this.window().on("resize", this._onResize.bind(this)),
          this.on(
            "keydown",
            selectors$6.cardWrapper,
            this._onCardTabDown.bind(this)
          ),
          this.on("keyup", this._onCardTabUp.bind(this)),
          utils.promiseStylesheet().then(
            function () {
              (this.cardsLoaded = this._loadCards()),
                $("html").removeClass("site-footer--hidden"),
                $(selectors$6.cardListSub, this.$container)
                  .prepareTransition()
                  .addClass(classes$6.cardListSubLoaded);
            }.bind(this)
          );
      },
      _onResize: function () {
        var columnCount = utils.isMobile()
          ? this.mobileColumnCount
          : this.desktopColumnCount;
        this.columnCount !== columnCount &&
          ((this.columnCount = columnCount),
          (this.$columns = this._replaceColumns())),
          $.each(
            this.$cards,
            function (index) {
              if (utils.isMobile())
                this.$columns.find(selectors$6.cardWrapper).removeAttr("style");
              else if (this._isAlignedRow(index + 1)) {
                var rowNumber =
                  (index - (index % this.desktopColumnCount)) /
                    this.desktopColumnCount +
                  1;
                this._matchRowHeights(this.$columns, rowNumber);
              }
            }.bind(this)
          );
      },
      _onCardTabDown: function (evt) {
        if (evt.keyCode === 9) {
          var index = $(evt.target).data("tabindex");
          (this.tabFromList = !0),
            evt.shiftKey
              ? index > 1 &&
                (evt.preventDefault(),
                $("[data-tabindex=" + (index - 1) + "]").focus())
              : index === this.$cards.length
              ? $(selectors$6.cardWrapper, this.$container).last().focus()
              : (evt.preventDefault(),
                $("[data-tabindex=" + (index + 1) + "]").focus());
        }
      },
      _onCardTabUp: function (evt) {
        if (evt.keyCode === 9) {
          var tabFromList = this.tabFromList || !1;
          (this.tabFromList = !1),
            !(!evt.shiftKey || tabFromList) &&
              $(selectors$6.cardWrapper, this.$container)
                .last()
                .is(evt.target) &&
              $("[data-tabindex=" + this.$cards.length + "]").focus();
        }
      },
      _loadCards: function () {
        return (
          this.trigger("cards_load_start"),
          (this.$columns = this._addColumns()),
          this._promiseAllCardsReveal().always(
            function () {
              this.trigger("cards_load_done");
            }.bind(this)
          )
        );
      },
      _addColumns: function () {
        for (var $columns, i2 = 1; i2 < this.columnCount; i2++)
          this.$cardList.append(this.$emptyColumn.clone());
        return (
          ($columns = $(selectors$6.cardListColumn, this.$container)),
          ($columns.heights = fill(Array(this.columnCount), 0)),
          ($columns.lengths = fill(Array(this.columnCount), 0)),
          $columns
        );
      },
      _replaceColumns: function () {
        var $columns = this.$emptyColumn.clone();
        ($columns.heights = fill(Array(this.columnCount), 0)),
          ($columns.lengths = fill(Array(this.columnCount), 0));
        for (var i2 = 1; i2 < this.columnCount; i2++)
          $columns.push(this.$emptyColumn.clone()[0]);
        return (
          $.each(
            this.$cards,
            function (index, card) {
              this._positionCard($(card), index, $columns);
            }.bind(this)
          ),
          this.$cardList.html($columns),
          $columns
        );
      },
      _promiseAllCardsReveal: function () {
        var series = $.Deferred().resolve();
        return (
          this.$cards.each(
            function (index, card) {
              if (
                (this._positionCard($(card), index, this.$columns),
                !utils.isMobile() && this._isAlignedRow(index + 1))
              ) {
                var rowNumber = this.$columns.lengths[0];
                this._matchRowHeights(this.$columns, rowNumber);
              }
              var promiseRevealReady = this._promiseRevealReady(card);
              series = series
                .then(function () {
                  return promiseRevealReady;
                })
                .then(this._revealCard.bind(this, card))
                .then(function () {
                  return $.Deferred(function (defer) {
                    setTimeout(defer.resolve, 80);
                  });
                });
            }.bind(this)
          ),
          series
        );
      },
      _revealCard: function (card) {
        var $card = $(card);
        this.trigger("card_loaded", [$card[0]]),
          requestAnimationFrame(
            $card.addClass.bind($card, classes$6.cardReveal)
          );
      },
      _promiseRevealReady: function (card) {
        return $.Deferred(function (defer) {
          var $card = $(card);
          if ($("html").hasClass("is-ios") && Shopify.designMode)
            $(card).addClass(classes$6.cardReveal), defer.resolve();
          else {
            let onAnimate2 = function (evt, element) {
              element === card &&
                ($card.off("animate_element", onAnimate2), defer.resolve());
            };
            var onAnimate = onAnimate2;
            requestAnimationFrame(function () {
              if (utils.isInOrAboveViewport(card)) return defer.resolve();
            }),
              $card.on("animate_element", onAnimate2);
          }
        });
      },
      _positionCard: function ($card, index, $columns) {
        var columnIndex = 0,
          cardHeight = $card.outerHeight(!0);
        if (this.gridStyle === "collage") {
          columnIndex = $columns.heights.indexOf(
            Math.min.apply(Math, $columns.heights)
          );
          for (var threshold = 150, i2 = 0; i2 < $columns.heights.length; i2++)
            if (
              $columns.heights[columnIndex] >
              $columns.heights[i2] - threshold
            ) {
              columnIndex = i2;
              break;
            }
        } else
          columnIndex = $columns.lengths.indexOf(
            Math.min.apply(Math, $columns.lengths)
          );
        $columns.eq(columnIndex).append($card),
          $card.outerHeight() === 0 &&
            !utils.isMobile() &&
            $card.find(selectors$6.cardWrapper).outerHeight(cardHeight),
          this.gridStyle === "collage" &&
            ($columns.heights[columnIndex] += cardHeight),
          $columns.lengths[columnIndex]++,
          $card.find("a").attr("data-tabindex", index + 1);
      },
      _matchRowHeights: function ($columns, rowNumber) {
        for (
          var maxHeight = 0,
            currentCardHeight = 0,
            rowSelector = "",
            isArticle = !1,
            i2 = 0;
          i2 < $columns.length;
          i2++
        )
          (rowSelector +=
            "[data-tabindex='" +
            ((rowNumber - 1) * $columns.length + i2 + 1) +
            "']"),
            i2 < $columns.length - 1 && (rowSelector += ", ");
        for (
          var $row = $columns.find(rowSelector).parent(), j = 0;
          j < $row.length;
          j++
        )
          (isArticle = $($row[j])
            .find(selectors$6.cardWrapper)
            .is(".card--article")),
            (currentCardHeight = $($row[j])
              .find(selectors$6.cardWrapper)
              .outerWidth()),
            $(document.body).hasClass(classes$6.searchTemplate) && isArticle
              ? (currentCardHeight = $($row[j])
                  .find(selectors$6.cardWrapper)
                  .outerHeight())
              : (currentCardHeight =
                  $($row[j]).find(selectors$6.cardWrapper).outerWidth() +
                  $($row[j]).find(selectors$6.cardInfo).outerHeight()),
            currentCardHeight > maxHeight && (maxHeight = currentCardHeight);
        $row.find(selectors$6.cardWrapper).outerHeight(maxHeight);
      },
      _isAlignedRow: function (index) {
        return (
          this.gridStyle === "grid" &&
          (index % this.desktopColumnCount === 0 ||
            index === this.$cards.length)
        );
      },
    };
  sections.register("blog-template", {
    onLoad: function () {
      this.extend(cardManager);
    },
  });
  var cart = {
      isUpdating: !1,
      getCart: function () {
        return $.getJSON("/cart.js");
      },
      on: function (event, cb) {
        $(this).on(event, cb);
      },
      trigger: function (event, data2) {
        $(this).triggerHandler(event, data2);
      },
      updateNote: function (note) {
        return this._promiseChange({
          url: "/cart/update.js",
          dataType: "json",
          data: { note: note || "" },
        });
      },
      addItem: function (id, quantity) {
        return this._promiseChange({
          url: "/cart/add.js",
          dataType: "json",
          data: { id, quantity: typeof quantity > "u" ? 1 : quantity },
        });
      },
      addItemFromForm: function (data2) {
        return this._promiseChange({
          url: "/cart/add.js",
          dataType: "json",
          processData: !1,
          contentType: !1,
          type: "POST",
          data: data2,
        });
      },
      removeItem: function (id) {
        return this._promiseChange({
          url: "/cart/change.js",
          dataType: "json",
          data: { id, quantity: 0 },
        });
      },
      changeItem: function (id, quantity) {
        return this._promiseChange({
          url: "/cart/change.js",
          dataType: "json",
          data: { id, quantity },
        });
      },
      saveLocalState: function (state) {
        return (
          utils.isLocalStorageSupported() &&
            (localStorage.shopify_cart_state = JSON.stringify(state)),
          state
        );
      },
      getLocalState: function () {
        if (utils.isLocalStorageSupported())
          return JSON.parse(localStorage.shopify_cart_state || "");
      },
      _promiseChange: function (parameters) {
        var promiseRequest = $.ajax(parameters);
        return (
          (this.isUpdating = !0),
          navigator &&
            !theme.isOnline &&
            (promiseRequest = $.Deferred().reject()),
          promiseRequest
            .then(
              function (state) {
                return typeof state.token > "u" ? this.getCart() : state;
              }.bind(this)
            )
            .then(function (cart) {
              this.cartData = cart;
              return cart;
            }.bind(this))
            .then(this.saveLocalState)
            .then(this._triggerChangeEvent.bind(this))
            .catch(this._triggerErrorEvent.bind(this))
            .always(
              function () {
                var cart = this.cartData;
                // 推奨商品セット表示処理
                var isRecommendPackbagSet = !1,
                  isRecommendPackbagPlusSet = !1;
                $(".cart-item").each(function () {
                  [7192304681123].find(
                    (e) => e == $(this).attr("data-product-id")
                  ) && (isRecommendPackbagSet = !0),
                    [7504024043683].find(
                      (e) => e == $(this).attr("data-product-id")
                    ) && (isRecommendPackbagPlusSet = !0);
                }),
                isRecommendPackbagSet
                  ? $(".cart").addClass("cart--recommend-packbag-set")
                  : $(".cart").removeClass("cart--recommend-packbag-set"),
                isRecommendPackbagPlusSet
                  ? $(".cart").addClass("cart--recommend-packbag-plus-set")
                  : $(".cart").removeClass(
                      "cart--recommend-packbag-plus-set"
                    );
                // Tポロ送料無料キャンペーン前のコード
                // var discountTargetAmount = 1e4;
                // var currentSubtotal = cart.total_price / 100;
                // if (currentSubtotal >= discountTargetAmount) {
                //   $(".cart").addClass("cart--postage-free");
                // } else {
                //   var remaining = discountTargetAmount - currentSubtotal;
                //   $(".shipping-message-box__main-em").text(
                //     remaining.toLocaleString() + "円"
                //   );
                //   $(".cart").removeClass("cart--postage-free");
                // }

                //＊＊＊ ↓ Tポロ送料無料キャンペーン ↓ ＊＊＊//
                var tPoloProductId = 7729758830755;
                var discountTargetAmount = 10000;
                var currentSubtotal = cart.total_price / 100;

                // Tポロ1枚だけか？
                var tPoloOnly =
                  cart.items.length === 1 &&
                  cart.items[0].product_id === tPoloProductId &&
                  Number(cart.items[0].quantity) === 1;

                // 一旦非表示
                $(".shipping-message-box").hide();

                var discountTargetAmount = 1e4;
                var currentSubtotal = cart.total_price / 100;
                if (currentSubtotal >= discountTargetAmount) {
                  $(".cart").addClass("cart--postage-free");
                } else {
                  if (tPoloOnly) {
                    $(".shipping-message-box--tpolo").show();
                    $(".cart").addClass("cart--postage-free");
                  } else {
                    var remaining = discountTargetAmount - currentSubtotal;
                    $(".shipping-message-box__main-em").text(
                      remaining.toLocaleString() + "円"
                    );
                    $(".shipping-message-box--default").show();
                    $(".cart").removeClass("cart--postage-free");
                  }
                }
                //＊＊＊ ↑ Tポロ送料無料キャンペーン ↑ ＊＊＊//
                this.isUpdating = false;
              }.bind(this)
            )
        );
      },
      _triggerChangeEvent: function (state) {
        return this.trigger("change", state), state;
      },
      _triggerErrorEvent: function (error) {
        throw (this.trigger("error", error), error);
      },
    },
    moneyFormat = "${{amount}}",
    currency = {
      formatMoney: function (cents, format) {
        typeof cents == "string" && (cents = cents.replace(".", ""));
        var value = "",
          placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
          formatString = format || moneyFormat;
        function formatWithDelimiters(number, precision, thousands, decimal) {
          if (
            ((precision = defaultTo(precision, 2)),
            (thousands = defaultTo(thousands, ",")),
            (decimal = defaultTo(decimal, ".")),
            isNaN(number) || number === null)
          )
            return 0;
          number = (number / 100).toFixed(precision);
          var parts = number.split("."),
            dollarsAmount = parts[0].replace(
              /(\d)(?=(\d\d\d)+(?!\d))/g,
              "$1" + thousands
            ),
            centsAmount = parts[1] ? decimal + parts[1] : "";
          return dollarsAmount + centsAmount;
        }
        switch (formatString.match(placeholderRegex)[1]) {
          case "amount":
            value = formatWithDelimiters(cents, 2);
            break;
          case "amount_no_decimals":
            value = formatWithDelimiters(cents, 0);
            break;
          case "amount_with_comma_separator":
            value = formatWithDelimiters(cents, 2, ".", ",");
            break;
          case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(cents, 0, ".", ",");
            break;
          case "amount_no_decimals_with_space_separator":
            value = formatWithDelimiters(cents, 0, " ");
            break;
          case "amount_with_apostrophe_separator":
            value = formatWithDelimiters(cents, 2, "'");
            break;
        }
        return formatString.replace(placeholderRegex, value);
      },
    },
    images = {
      preload: function (images2, size) {
        typeof images2 == "string" && (images2 = [images2]);
        for (var i2 = 0; i2 < images2.length; i2++) {
          var image = images2[i2];
          this.loadImage(this.getSizedImageUrl(image, size));
        }
      },
      loadImage: function (path) {
        new Image().src = path;
      },
      switchImage: function (image, element, callback) {
        var size = this.imageSize(element.src),
          imageUrl = this.getSizedImageUrl(image.src, size);
        callback
          ? callback(imageUrl, image, element)
          : (element.src = imageUrl);
      },
      imageSize: function (src) {
        src = src || "";
        var match = src.match(
          /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
        );
        return match !== null ? match[1] : null;
      },
      getSizedImageUrl: function (src, size) {
        if (size === null) return src;
        if (size === "master") return this.removeProtocol(src);
        var match = src.match(
          /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
        );
        if (match !== null) {
          var prefix = src.split(match[0]),
            suffix = match[0];
          return this.removeProtocol(prefix[0] + "_" + size + suffix);
        }
        return null;
      },
      removeProtocol: function (path) {
        return path.replace(/http(s)?:/, "");
      },
    },
    data = { itemId: "data-cart-item-id", productId: "data-product-id" },
    selectors$8 = {
      ajaxCart: ".cart-drawer",
      itemList: "[data-cart-item-list]",
      item: "[data-cart-item]",
      itemId: "[data-cart-item-id]",
      itemHref: "[data-cart-item-href]",
      itemImage: "[data-cart-item-image]",
      itemBackgroundImage: "[data-cart-item-background-image]",
      itemTitle: "[data-cart-item-title]",
      itemVariantTitle: "[data-cart-item-variant-title]",
      itemPropertyList: "[data-cart-item-property-list]",
      itemProperty: "[data-cart-item-property]",
      itemDiscountList: "[data-cart-item-discount-list]",
      itemDiscount: "[data-cart-item-discount]",
      itemDiscountTitle: "[data-cart-item-discount-title]",
      itemDiscountAmount: "[data-cart-item-discount-amount]",
      itemLabelQuantity: "[data-cart-item-label-quantity]",
      itemInputQuantity: "[data-cart-item-input-quantity]",
      itemDelete: "[data-cart-item-delete]",
      itemPriceContainer: "[data-cart-item-price-container]",
      itemLinePriceContainer: "[data-cart-item-line-price-container]",
      itemPoints: "[data-cart-item-points]",
      itemMessage: "[data-item-message]",
      cartDiscountContainer: "[data-cart-discount-container]",
      cartDiscount: "[data-cart-discount]",
      cartDiscountTitle: "[data-cart-discount-title]",
      cartDiscountAmount: "[data-cart-discount-amount]",
      cartNoteContainer: "[data-cart-note-container]",
      cartNoteInput: "[data-cart-note]",
      cartMessage: "[data-cart-message]",
      cartSubtotal: "[data-cart-subtotal]",
      cartSubmit: "[data-cart-submit]",
      productId: "[data-product-id]",
    },
    classes$8 = {
      cartTemplate: "ajax-cart__template",
      cartItemRemove: "ajax-cart__item--remove",
      cartError: "ajax-cart--error",
      visuallyHidden: "visually-hidden",
      cartDiscountActive: "ajax-cart__discount-container--active",
      btnLoaderActive: "btn--loader-active",
    },
    ajaxCart = {
      init: function () {
        (this.$ajaxCart = $(selectors$8.ajaxCart, this.$container)),
          (this.$itemTemplate = $(selectors$8.item, this.$container)
            .first()
            .clone()),
          (this.$propertyTemplate = $(selectors$8.itemProperty, this.$container)
            .first()
            .clone()),
          (this.$discountTemplate = $(selectors$8.itemDiscount, this.$container)
            .first()
            .clone()),
          (this.$cartDiscountTemplate = $(
            selectors$8.cartDiscount,
            this.$container
          )
            .first()
            .clone()),
          cart.on("quantity", this._onQuantityError.bind(this)),
          cart.on(
            "change",
            function (event, state) {
              this.update(state);
            }.bind(this)
          ),
          this.on(
            "input",
            selectors$8.itemInputQuantity,
            debounce(this._onItemQuantityChange.bind(this), 500)
          ),
          this.on(
            "blur",
            selectors$8.itemInputQuantity,
            this._onItemQuantityEmptyBlur.bind(this)
          ),
          this.on("focus", selectors$8.itemInputQuantity, this._highlightText),
          this.on(
            "click",
            selectors$8.itemDelete,
            this._onItemDelete.bind(this)
          ),
          this.on(
            "change",
            selectors$8.cartNoteInput,
            this._onNoteChange.bind(this)
          ),
          this.on("submit", this._onSubmit.bind(this)),
          this.window().on("storage", this._onStorageStateChange.bind(this));
      },
      refresh: function () {
        cart.getCart().then(this.update.bind(this));
      },
      update: function (state) {
        this.trigger("cart_update_start", [state]);
        var $cart = this._createCart(state);
        morphdom2(this.$container[0], $cart[0]),
          this.trigger("cart_update_done", [state]);
      },
      _onError: function (error) {
        this.trigger("cart_error", [error]),
          this.$container.addClass(classes$8.cartError),
          $(selectors$8.item, this.$container).removeClass(
            classes$8.cartItemRemove
          ),
          $(selectors$8.cartMessage, this.$container).text(
            theme.strings.cartError
          );
      },
      _onQuantityError: function (event, item) {
        this.trigger("cart_item_quantity_error", [item]),
          this.$container.addClass(classes$8.cartError);
        var quantityError = theme.strings.cartQuantityError
            .replace("[quantity]", item.quantity)
            .replace("[title]", item.title),
          $itemMessageElement = $(
            selectors$8.itemMessage,
            $("[" + data.itemId + '="' + item.key + '"]')
          );
        $itemMessageElement.removeAttr("aria-hidden"),
          $itemMessageElement.html(quantityError);
      },
      _createCart: function (state) {
        var $container = this.$container.clone();
        return (
          $container.removeClass(classes$8.cartError),
          $(selectors$8.cartMessage, $container).text(""),
          $(selectors$8.item, $container)
            .not(selectors$8.cartNoteContainer)
            .remove(),
          $(selectors$8.itemList, $container).prepend(
            this._createItemList(state)
          ),
          $(selectors$8.cartNoteInput, $container).val(state.note),
          $(selectors$8.cartDiscountContainer, $container).toggleClass(
            classes$8.cartDiscountActive,
            state.total_discount !== 0
          ),
          $(selectors$8.cartDiscountContainer, $container).html(
            this._createCartDiscountList(state)
          ),
          $(selectors$8.cartSubtotal, $container).attr(
            "data-loyal-changed",
            new Date().getTime()
          ),
          $(selectors$8.cartSubtotal, $container).html(
            currency.formatMoney(state.total_price, theme.moneyFormat)
          ),
          $(selectors$8.cartSubmit, $container).attr(
            "disabled",
            state.items.length === 0
          ),
          $container
        );
      },
      _createItemList: function (state) {
        return $.map(
          state.items,
          function (item) {
            var $item = this.$itemTemplate
                .clone()
                .removeClass(classes$8.cartTemplate),
              propertyList = this._createPropertyList(item),
              discountList = this._createDiscountList(item),
              itemPrice = this._createItemPrice(item),
              itemLinePrice = this._createItemTotalPrice(item);
            return (
              $item
                .find(selectors$8.productId)
                .addBack(selectors$8.productId)
                .attr(data.productId, item.product_id),
              $item
                .find(selectors$8.itemId)
                .addBack(selectors$8.itemId)
                .attr(data.itemId, item.key),
              $(selectors$8.itemHref, $item).attr("href", item.url),
              $(selectors$8.itemImage, $item)
                .attr(
                  "src",
                  item.image
                    ? images.getSizedImageUrl(item.image, "medium")
                    : ""
                )
                .toggleClass("hide", typeof item.image != "string"),
              $(selectors$8.itemBackgroundImage, $item).css(
                "background-image",
                item.image
                  ? "url(" + images.getSizedImageUrl(item.image, "medium") + ")"
                  : "none"
              ),
              $(selectors$8.itemTitle, $item).text(item.product_title),
              $(selectors$8.itemVariantTitle, $item).text(item.variant_title),
              $(selectors$8.itemPriceContainer, $item).html(itemPrice),
              $(selectors$8.itemLinePriceContainer, $item).html(itemLinePrice),
              $(selectors$8.itemLabelQuantity, $item).attr(
                "for",
                "quantity_" + item.key
              ),
              $(selectors$8.itemInputQuantity, $item)
                .attr("name", "updates[" + item.key + "]")
                .attr("id", "quantity_" + item.key)
                .val(item.quantity),
              $(selectors$8.itemPropertyList, $item).html(propertyList),
              $(selectors$8.itemDiscountList, $item).html(discountList),
              $item[0]
            );
          }.bind(this)
        );
      },
      _createItemPoints: function (price, show = !1) {
        var $points = $(
          selectors$8.itemPoints,
          this.$itemTemplate.clone()
        ).clone();
        return $points.length > 0
          ? ($('[data-loyal-target="point-value"]', $points).attr(
              "data-loyal-currency-cost",
              price
            ),
            $('[data-loyal-target="point-value-location"]', $points).text("-"),
            $($points).attr("data-loyal-changed", new Date().getTime()),
            show && $($points).removeClass("easy-points-hide"),
            $points[0].outerHTML)
          : "";
      },
      _createItemPrice: function (item) {
        var itemPrice = "";
        return (
          (itemPrice += this._createItemProductPrice(
            item.original_price,
            item.final_price
          )),
          (itemPrice += this._createItemPoints(item.final_price)),
          item.unit_price_measurement &&
            (itemPrice += this._createItemUnitPrice(item)),
          itemPrice
        );
      },
      _createItemTotalPrice: function (item) {
        var itemPrice = "";
        return (
          (itemPrice += this._createItemProductPrice(
            item.original_line_price,
            item.final_line_price
          )),
          (itemPrice += this._createItemPoints(item.final_line_price, !0)),
          itemPrice
        );
      },
      _createItemProductPrice: function (original_price, final_price) {
        var itemPrice = "";
        return (
          original_price !== final_price
            ? (itemPrice +=
                '<span class="visually-hidden">' +
                theme.strings.regularPrice +
                '</span><del class="cart-item__original-price">' +
                currency.formatMoney(original_price, theme.moneyFormat) +
                '</del><span class="visually-hidden">' +
                theme.strings.salePrice +
                '</span><span class="order-discount cart-item__price">' +
                currency.formatMoney(final_price, theme.moneyFormat) +
                "</span>")
            : (itemPrice +=
                '<span class="cart-item__original-price cart-item__price">' +
                currency.formatMoney(original_price, theme.moneyFormat) +
                "</span>"),
          itemPrice
        );
      },
      _createItemUnitPrice: function (item) {
        return (
          '<span class="product-price-unit"><span class="visually-hidden">' +
          theme.strings.unitPrice +
          "</span><span>" +
          currency.formatMoney(item.unit_price, theme.moneyFormat) +
          '</span><span aria-hidden="true">/</span><span class="visually-hidden">&nbsp;' +
          theme.strings.unitPriceSeparator +
          "&nbsp;</span><span>" +
          (item.unit_price_measurement.reference_value !== 1
            ? item.unit_price_measurement.reference_value
            : "") +
          item.unit_price_measurement.reference_unit +
          "</span></span>"
        );
      },
      _createPropertyList: function (item) {
        return $.map(
          item.properties,
          function (value, key) {
            var $property = this.$propertyTemplate
              .clone()
              .removeClass(classes$8.cartTemplate);
            if (key.charAt(0) !== "_" && value !== "")
              return (
                value.indexOf("/uploads/") === -1
                  ? $property.text(key + ": " + value)
                  : $property.html(
                      key +
                        ': <a href="' +
                        value +
                        '">' +
                        value.split("/").pop() +
                        "</a>"
                    ),
                $property[0]
              );
          }.bind(this)
        );
      },
      _createDiscountList: function (item) {
        return $.map(
          item.line_level_discount_allocations,
          function (discount) {
            var $discount = this.$discountTemplate
              .clone()
              .removeClass(classes$8.cartTemplate);
            return (
              $discount
                .find(selectors$8.itemDiscountTitle)
                .text(discount.discount_application.title),
              $discount
                .find(selectors$8.itemDiscountAmount)
                .html(currency.formatMoney(discount.amount, theme.moneyFormat)),
              $discount[0]
            );
          }.bind(this)
        );
      },
      _createCartDiscountList: function (cart$$1) {
        return $.map(
          cart$$1.cart_level_discount_applications,
          function (discount) {
            var $discount = this.$cartDiscountTemplate
              .clone()
              .removeClass(classes$8.cartTemplate);
            return (
              $discount
                .find(selectors$8.cartDiscountTitle)
                .text(discount.title),
              $discount
                .find(selectors$8.cartDiscountAmount)
                .html(
                  currency.formatMoney(
                    discount.total_allocated_amount,
                    theme.moneyFormat
                  )
                ),
              $discount[0]
            );
          }.bind(this)
        );
      },
      _onStorageStateChange: function (evt) {
        if (evt.key === "shopify_cart_state") {
          var state = cart.getLocalState();
          this.trigger("cart_storage_state_change", [state]),
            this.update(cart.getLocalState());
        }
      },
      _onItemQuantityChange: function (evt) {
        var $input = $(evt.target),
          id = $input.closest(selectors$8.item).attr(data.itemId),
          quantity = $input.val();
        quantity !== "" &&
          (this.trigger("cart_item_quantity_change", [id, quantity]),
          cart.changeItem(id, quantity).catch(this._onError.bind(this)));
      },
      _onItemQuantityEmptyBlur: function (evt) {
        var $input = $(evt.target),
          value = $input.val();
        value === "" && this.refresh();
      },
      _onItemDelete: function (evt) {
        evt.preventDefault();
        var $deleteButton = $(evt.target),
          $items = $(selectors$8.item, this.$container),
          $item = $deleteButton.closest(selectors$8.item),
          $note = $(selectors$8.cartNoteContainer, this.$container),
          id = $item.attr(data.itemId);
        $item.remove(),
          this.trigger("cart_item_remove", [id]),
          $items.length === 2 &&
            $items.last().is($note) &&
            ($note.addClass(classes$8.cartItemRemove),
            utils
              .promiseTransitionEnd($(selectors$8.itemList, this.$container))
              .then(function () {
                $note.removeClass(classes$8.cartItemRemove);
              })),
          $item.addClass(classes$8.cartItemRemove),
          utils.promiseAnimationEnd($item).then(
            function () {
              cart.removeItem(id).catch(this._onError.bind(this));
            }.bind(this)
          );
      },
      _onNoteChange: function (evt) {
        var value = $(evt.target).val();
        this.trigger("cart_note_change", [value]),
          cart.updateNote(value).catch(this._onError.bind(this));
      },
      _onSubmit: function (evt) {
        cart.isUpdating
          ? evt.preventDefault()
          : ($(selectors$8.cartSubmit, this.$container).addClass(
              classes$8.btnLoaderActive
            ),
            this.trigger("cart_submit"));
      },
      _highlightText: function (evt) {
        $(evt.target).select();
      },
    },
    classes$9 = {
      drawerActive: "drawer--active",
      disableScroll: "disable-scroll",
    },
    selectors$9 = {
      drawerPush: "[data-drawer-push]",
      drawerCover: ".drawer-cover",
      mainContent: ".main-content",
      siteHeader: ".site-header",
    },
    drawer = {
      init: function () {
        (this.$toggleButton = null),
          (this.draggingAction = null),
          (this.namespaceTouch = ".onTouchStart"),
          (this.namespaceOpen = ".onOpen"),
          this.document().on("resize", this._onWindowResize.bind(this));
      },
      drawerOpen: function (evt) {
        this.trigger("drawer_open_start"),
          a11y$1.trapFocus({
            $container: this.$container,
            namespace: "drawer",
          }),
          evt &&
            evt.currentTarget &&
            (this.$toggleButton = $(evt.target).attr("aria-expanded", !0)),
          utils.disableScrollBody(),
          $("body").addClass(classes$9.drawerActive),
          this.trigger("drawer_open_transitioning"),
          utils.promiseTransitionEnd(this.$container).then(
            function () {
              utils.enableTabbingOfChildren(this.$container),
                this.$container.attr("aria-hidden", !1),
                this.document().on(
                  "click touchend" + this.namespaceOpen,
                  selectors$9.drawerCover,
                  this.drawerClose.bind(this)
                ),
                this.document().on(
                  "keyup" + this.namespaceOpen,
                  this._closeOnEscape.bind(this)
                ),
                this.document().on(
                  "touchstart" + this.namespaceOpen,
                  this._onTouchStart.bind(this)
                ),
                this.trigger("drawer_open_done");
            }.bind(this)
          );
      },
      drawerClose: function () {
        this.trigger("drawer_close_start"),
          a11y$1.removeTrapFocus({ namespace: "drawer" }),
          this.$toggleButton &&
            this.$toggleButton.length &&
            (this.$toggleButton.focus().attr("aria-expanded", !1),
            (this.$toggleButton = null)),
          utils.enableScrollBody(),
          utils.disableTabbingOfChildren(this.$container),
          this.$container.attr("aria-hidden", !0),
          this.document().off(this.namespaceOpen),
          $("body").removeClass(classes$9.drawerActive),
          this.trigger("drawer_close_transitioning"),
          utils.promiseTransitionEnd(this.$container).then(
            function () {
              this.trigger("drawer_close_done");
            }.bind(this)
          );
      },
      _onWindowResize: function () {
        this.sliderWidth = 0;
      },
      _onTouchStart: function (event) {
        (this.startPosition = utils.pointerEventToXY(event)),
          (this.$elementsToPush =
            this.$elementsToPush || $(selectors$9.drawerPush)),
          (this.sliderWidth = this.sliderWidth || this.$container.width()),
          (this.isDragging = !1),
          this.document().on(
            "touchmove" + this.namespaceTouch,
            this._onTouchMove.bind(this)
          ),
          this.document().on(
            "touchend" + this.namespaceTouch,
            this._onTouchEnd.bind(this)
          );
      },
      _onTouchMove: function (event) {
        var dx, dy, deg, transform;
        (this.isDragging = !0),
          (this.currentPosition = utils.pointerEventToXY(event)),
          this.trigger("drawer_dragging", [this.currentPosition]),
          (dx = this.currentPosition.x - this.startPosition.x),
          (dy = this.currentPosition.y - this.startPosition.y),
          (deg = Math.atan2(dx, dy) / (Math.PI / 180)),
          (this.translated = dx > 0 ? dx : 0),
          Math.abs(deg) > 65 &&
          Math.abs(deg) < 115 &&
          this.draggingAction === null
            ? (this.draggingAction = "slide")
            : (Math.abs(deg) < 65 || Math.abs(deg) > 115) &&
              this.draggingAction === null &&
              (this.draggingAction = "scroll"),
          this.draggingAction === "slide" &&
            (event.preventDefault(),
            (transform = {
              transform:
                "translateX(-" + (this.sliderWidth - this.translated) + "px)",
              transition: "none",
            }),
            this.$elementsToPush.css(transform));
      },
      _onTouchEnd: function () {
        var percentMoved;
        (this.wasDragging = this.isDragging),
          (this.isDragging = !1),
          this.wasDragging &&
            ((percentMoved = this.translated / this.sliderWidth),
            percentMoved > 0.25 && this.draggingAction === "slide"
              ? (this.drawerClose("ease-out"),
                this.trigger("drawer_dragging_success"))
              : this.trigger("drawer_dragging_fail"),
            this.$elementsToPush.removeAttr("style")),
          (this.draggingAction = null),
          this.document().off(this.namespaceTouch);
      },
      _closeOnEscape: function (evt) {
        evt.keyCode === 27 && this.drawerClose();
      },
    },
    selectors$7 = {
      drawer: ".drawer",
      cartHeader: ".cart-drawer__header",
      cartTitle: ".cart-drawer__header-title",
      cartContent: ".cart-drawer__content",
      cartToggle: ".ajax-cart__toggle",
      cartCloseButton: ".cart-drawer__close-button",
      siteHeader: ".site-header",
    },
    classes$7 = {
      cartTemplate: "template-cart",
      cartEmpty: "cart-drawer--empty",
      cartNoCookies: "cart-drawer--no-cookies",
    };
  sections.register("cart-drawer", {
    onLoad: function () {
      if (!$(document.body).hasClass(classes$7.cartTemplate)) {
        if (
          (this.extend(drawer),
          this._setDrawerHeaderHeight(),
          this.on("drawer_close_done", this._onDrawerClose.bind(this)),
          this.document().on(
            "click",
            selectors$7.cartToggle,
            this._openCartDrawer.bind(this)
          ),
          !utils.cookiesEnabled())
        ) {
          this.$container.addClass(classes$7.cartNoCookies);
          return;
        }
        this.extend(ajaxCart),
          cart.on(
            "change",
            function (event, state) {
              this.$ajaxCart.toggleClass(
                classes$7.cartEmpty,
                state.items.length === 0
              );
            }.bind(this)
          );
      }
    },
    onSelect: function () {
      this._openCartDrawer();
    },
    onDeselect: function () {
      this._closeCartDrawer();
    },
    _onDrawerClose: function () {
      sections.getInstances("header-section").then(function (instances) {
        instances[0].scrollHandler = !0;
      });
    },
    _setDrawerHeaderHeight: function () {
      var $cartHeader = $(selectors$7.cartHeader, this.$container),
        siteHeaderHeight = $(selectors$7.siteHeader).outerHeight();
      $cartHeader.css("height", siteHeaderHeight);
    },
    _openCartDrawer: function (evt) {
      evt.preventDefault(),
        sections
          .getInstances("header-section")
          .then(function (instances) {
            return (
              (instances[0].scrollHandler = !1), instances[0].hideNavigation()
            );
          })
          .then(
            function () {
              this.drawerOpen(evt),
                $(selectors$7.cartContent, this.$container).scrollTop(0),
                a11y$1.forceFocus($(selectors$7.cartTitle, this.$container)),
                this.$container.on(
                  "click",
                  selectors$7.cartCloseButton,
                  this._closeCartDrawer.bind(this)
                );
            }.bind(this)
          );
    },
    _closeCartDrawer: function () {
      this.drawerClose();
    },
  });
  var classes$10 = {
    showClass: "cart-item__update--show",
    showEditClass: "cart-item__edit--active",
    cartEmpty: "cart--empty",
    cartNoCookies: "cart--no-cookies",
  };
  sections.register("cart-template", {
    onLoad: function () {
      var $container = $(this.container);
      if (!utils.cookiesEnabled()) {
        $container.addClass(classes$10.cartNoCookies);
        return;
      }
      this.extend(ajaxCart),
        cart.on("change", function (event, state) {
          $container.toggleClass(
            classes$10.cartEmpty,
            state.items.length === 0
          );
        });
    },
  });
  var selectors$10 = {
      filterBy: "#FilterBy",
      sortBy: "#SortBy",
      collectionImage: ".section-header-image",
    },
    defaultSort = "title-ascending",
    queryParams = {};
  sections.register("collection-template", {
    onLoad: function () {
      var $container = (this.$container = $(this.container)),
        $filterBy = $(selectors$10.filterBy, $container),
        $sortBy = $(selectors$10.sortBy, $container);
      (this.defaultSort = this.getDefaultSortValue()),
        this.extend(cardManager),
        this.initParams(),
        $filterBy.on("change", this.onFilterChange.bind(this)),
        $sortBy.on("change", this.onSortChange.bind(this));
    },
    initParams: function () {
      if (location.search.length)
        for (
          var aKeyValue,
            aCouples = location.search.substr(1).split("&"),
            i2 = 0;
          i2 < aCouples.length;
          i2++
        )
          (aKeyValue = aCouples[i2].split("=")),
            aKeyValue.length > 1 &&
              (queryParams[decodeURIComponent(aKeyValue[0])] =
                decodeURIComponent(aKeyValue[1]));
    },
    onSortChange: function () {
      (queryParams.sort_by = this.getSortValue()),
        queryParams.page && delete queryParams.page,
        (location.search = decodeURIComponent($.param(queryParams)));
    },
    onFilterChange: function () {
      (this.filter = this.getFilterValue()),
        (document.location.href = this.filter);
    },
    getSortValue: function () {
      return $(selectors$10.sortBy).val() || this.defaultSort;
    },
    getDefaultSortValue: function () {
      return $(selectors$10.sortBy, this.$container).val() || defaultSort;
    },
    getFilterValue: function () {
      return (
        $(selectors$10.filterBy, this.$container).val() || "collections/all"
      );
    },
  }),
    sections.register("featured-blog", {
      onLoad: function () {
        this.extend(cardManager);
      },
    });
  var product = {
      validate: function (product2) {
        if (typeof product2 != "object" || typeof product2.id != "number")
          throw Error(
            "Please pass a valid Product object to the Product Controller"
          );
        return $.extend({}, product2);
      },
      getVariant: function (product2, value) {
        var variant;
        return (
          typeof value == "string" || typeof value == "number"
            ? (variant = this._getVariantFromId(product2, value))
            : typeof value == "object" && typeof value.id == "number"
            ? (variant = this._getVariantFromId(product2, value.id))
            : isArray(value) &&
              (typeof value[0] == "object"
                ? (variant = this._getVariantFromOptionCollection(
                    product2,
                    value
                  ))
                : (variant = this._getVariantFromOptionArray(product2, value))),
          variant
        );
      },
      optionArrayFromOptionCollection: function (product2, collection) {
        var optionArray = [];
        return (
          collection.forEach(function (option) {
            var index;
            if (typeof option.name != "string")
              throw Error(
                "Invalid value type passed for name of option " +
                  index +
                  ". Value should be string."
              );
            if (
              ((index = findIndex(product2.options, function (name) {
                return name.toLowerCase() === option.name.toLowerCase();
              })),
              index === -1)
            )
              throw Error("Invalid option name, " + option.name);
            optionArray[index] = option.value;
          }),
          optionArray
        );
      },
      _getVariantFromId: function (product2, id) {
        return find(product2.variants, { id });
      },
      _getVariantFromOptionCollection: function (
        product2,
        collection,
        closest
      ) {
        var optionArray = this.optionArrayFromOptionCollection(
          product2,
          collection
        );
        return this._getVariantFromOptionArray(product2, optionArray, closest);
      },
      _getVariantFromOptionArray: function (product2, options) {
        return find(product2.variants, function (variant) {
          return options.every(function (option, index) {
            return variant.options[index] === option;
          });
        });
      },
    },
    classes$11 = {
      productPriceSale: "product__price--sale",
      productPriceUnitUnavailable: "product-price-unit--unavailable",
      productNotificationSuccess: "product__notification--success",
      productNotificationError: "product__notification--error",
      buttonTransition: "btn--to-secondary-transitioned",
      ajaxCartToggle: "ajax-cart__toggle",
      hide: "hide",
      lazyPreload: "lazypreload",
    },
    selectors$12 = {
      productForm: ".product-form",
      selectorWrapper: ".product-form__item",
      ajaxCartToggle: ".ajax-cart__toggle",
      shopifyPaymentButton: ".shopify-payment-button",
      productJSON: "[data-product-json]",
      optionInputs: "[data-option-input]",
      masterSelect: "[data-master-select]",
      variantMediaImage: "[data-variant-media-image]",
      variantMediaToggleHide: "[data-variant-media-toggle-hide]",
      productPrice: "[data-product-price]",
      regularPrice: "[data-regular-price]",
      compareAtPrice: "[data-compare-price]",
      unitPrice: "[data-unit-price]",
      unitPriceBaseUnit: "[data-unit-price-base-unit]",
      unitPriceContainer: "[data-unit-price-container]",
      submitButton: "[data-cart-submit]",
      submitButtonPrimaryText: "[data-cart-primary-submit-text]",
      submitButtonSecondaryText: "[data-cart-secondary-submit-text]",
      notification: "[data-cart-notification]",
      shopifyXr: "[data-shopify-xr]",
    },
    productDisplay = {
      init: function () {
        var $productJSON = $(selectors$12.productJSON, this.container);
        $productJSON.length !== 0 &&
          ((this.product = JSON.parse($productJSON.html())),
          (this.variant = product.getVariant(
            this.product,
            this.$container.data("variant-id")
          )),
          this._formatVariantSelectors(),
          this.on(
            "submit",
            selectors$12.productForm,
            this._addItemToCart.bind(this)
          ),
          this.one(
            "focus",
            selectors$12.optionInputs,
            this._preloadVariantMediaImages.bind(this)
          ),
          this.on(
            "change.variantController",
            selectors$12.optionInputs,
            this.update.bind(this)
          ),
          this.document().on(
            "click",
            selectors$12.ajaxCartToggle,
            this._resetAddToCartButton.bind(this)
          ),
          this.window().on("online", this._updateOnlineStatus),
          this.window().on("offline", this._updateOfflineStatus));
      },
      update: function () {
        var $inputs = $(selectors$12.optionInputs, this.$container),
          options = $inputs.serializeArray(),
          variant = product.getVariant(this.product, options);
        typeof variant > "u"
          ? (this.trigger("variant_change_undefined", [this.product, options]),
            (variant = $.extend({}, this.variant)),
            (variant.isUndefined = !0),
            (variant.available = !1),
            (variant.options = product.optionArrayFromOptionCollection(
              this.product,
              options
            )))
          : this.trigger("variant_change_successful", [this.product, variant]),
          (this.variant = variant),
          morphdom2(this.$container[0], this._updatedContainer(this.variant)),
          this.trigger("variant_change", [this.product, variant]);
      },
      _preloadVariantMediaImages: function () {
        $(selectors$12.variantMediaImage, this.$container).addClass(
          classes$11.lazyPreload
        );
      },
      _formatVariantSelectors: function () {
        utils.promiseStylesheet().then(
          function () {
            $(selectors$12.selectorWrapper, this.$container).each(function () {
              var $wrapper = $(this),
                $label = $wrapper.find("label"),
                $input = $wrapper.find("select, input");
              $input.css({ "padding-left": $label.outerWidth(), opacity: 1 });
            });
          }.bind(this)
        );
      },
      _updatedContainer: function (variant) {
        var $container = this.$container.clone();
        return (
          $(selectors$12.masterSelect, $container).val(variant.id),
          this._updateInputValues(variant, $container),
          this._updateProductPrices(variant, $container),
          this._updateVariantMediaImage(variant, $container),
          this._toggleVariantMediaHide(variant, $container),
          this._updateCartButtonState(variant, $container),
          $container[0]
        );
      },
      _updateInputValues: function (variant, $container) {
        $(selectors$12.optionInputs, $container).each(function (index) {
          $(this).val(variant.options[index]);
        });
      },
      _updateCartButtonState: function (variant, $container) {
        var text;
        variant.isUndefined
          ? (text = theme.strings.unavailable)
          : (text = variant.available
              ? theme.strings.addToCart
              : theme.strings.soldOut),
          this._resetAddToCartButton($container),
          variant.available
            ? $(selectors$12.shopifyPaymentButton, $container).show()
            : $(selectors$12.shopifyPaymentButton, $container).hide(),
          $(selectors$12.submitButton, $container)
            .prop("disabled", !variant.available)
            .attr("aria-label", text),
          $(selectors$12.submitButtonPrimaryText, $container).text(text);
      },
      _updateProductPrices: function (variant, $container) {
        var productPrice = variant.price,
          comparePrice = variant.compare_at_price;
        $(selectors$12.regularPrice, $container).html(
          currency.formatMoney(productPrice, theme.moneyFormat)
        ),
          $(selectors$12.compareAtPrice, $container).html(
            currency.formatMoney(comparePrice, theme.moneyFormat)
          ),
          $(selectors$12.productPrice, $container).toggleClass(
            classes$11.productPriceSale,
            comparePrice > productPrice
          ),
          $(selectors$12.unitPriceContainer, $container).addClass(
            classes$11.productPriceUnitUnavailable
          ),
          variant.unit_price_measurement &&
            ($(selectors$12.unitPrice, $container).html(
              currency.formatMoney(variant.unit_price, theme.moneyFormat)
            ),
            $(selectors$12.unitPriceBaseUnit, $container).html(
              this.getBaseUnit(variant)
            ),
            $(selectors$12.unitPriceContainer, $container).removeClass(
              classes$11.productPriceUnitUnavailable
            ));
      },
      _updateVariantMediaImage: function (variant, $container) {
        var $variantMediaImage = $(selectors$12.variantMediaImage, $container);
        if (!(!this.product.media || !$variantMediaImage.length)) {
          var src =
              (variant.featured_media &&
                variant.featured_media.preview_image.src) ||
              this.product.media[0].preview_image.src,
            size = images.imageSize($variantMediaImage.attr("src")),
            sizedImgUrl = images.getSizedImageUrl(src, size);
          $variantMediaImage.attr("src", sizedImgUrl);
        }
      },
      _toggleVariantMediaHide: function (variant, $container) {
        if (!(!variant.featured_media && !this.product.featured_media)) {
          var media = variant.featured_media || this.product.featured_media.id,
            id = media && media.id,
            mediaId = this.id + "-" + id,
            $mediaGroup = $(selectors$12.variantMediaToggleHide, $container),
            $active = $mediaGroup.filter('[data-media-id="' + mediaId + '"]');
          $active
            .removeClass(classes$11.hide)
            .siblings()
            .not(selectors$12.shopifyXr)
            .addClass(classes$11.hide);
        }
      },
      _addItemToCart: function (evt) {
        if (sections.isInstance("cart-drawer")) {
          evt.preventDefault();
          var $button = $(selectors$12.submitButton, this.$container),
            data2 = new FormData(evt.target);
          $button.hasClass(classes$11.ajaxCartToggle) ||
            cart
              .addItemFromForm(data2)
              .then(
                function () {
                  this._transitionAddToCartButton.bind(this, data2),
                    sections
                      .getInstances("cart-drawer")
                      .then(function (instances) {
                        return instances[0]._openCartDrawer(evt);
                      });
                }.bind(this)
              )
              .catch(this._onAddItemFail.bind(this))
              .always(
                function () {
                  this.trigger("variant_add_to_cart", [
                    this.product,
                    this.variant,
                    data2,
                  ]);
                }.bind(this)
              );
        }
      },
      _onAddItemFail: function (response) {
        var $notification = $(selectors$12.notification, this.$container),
          responseText = response && response.responseText;
        return (
          responseText
            ? (responseText = JSON.parse(responseText).description)
            : (responseText = theme.strings.cartError),
          $notification
            .addClass(classes$11.productNotificationError)
            .removeClass(classes$11.productNotificationSuccess)
            .html(responseText)
            .attr("role", "alert"),
          this.trigger("variant_add_to_cart_fail", [
            this.product,
            this.variant,
            responseText,
          ]),
          utils.promiseTransitionEnd($notification)
        );
      },
      _transitionAddToCartButton: function (data2) {
        var $notification = $(selectors$12.notification, this.$container),
          $button = $(selectors$12.submitButton, this.$container),
          $primaryButtonText = $(selectors$12.submitButtonPrimaryText, $button),
          $secondaryButtonText = $(
            selectors$12.submitButtonSecondaryText,
            $button
          );
        return (
          $button
            .addClass(
              [classes$11.buttonTransition, classes$11.ajaxCartToggle].join(" ")
            )
            .attr("aria-label", theme.strings.viewCart),
          $primaryButtonText.attr("aria-hidden", !0),
          $secondaryButtonText.attr("aria-hidden", !1),
          $notification
            .removeClass(classes$11.productNotificationError)
            .addClass(classes$11.productNotificationSuccess)
            .text(theme.strings.addItemSuccess)
            .attr("role", "alert"),
          this.trigger("variant_add_to_cart_successful", [
            this.product,
            this.variant,
            data2,
          ]),
          utils.promiseTransitionEnd($notification)
        );
      },
      _resetAddToCartButton: function ($container) {
        $container = $container.length ? $container : this.$container;
        var $notification = $(selectors$12.notification, $container),
          $button = $(selectors$12.submitButton, $container),
          $primaryButtonText = $(selectors$12.submitButtonPrimaryText, $button),
          $secondaryButtonText = $(
            selectors$12.submitButtonSecondaryText,
            $button
          );
        $button
          .removeClass(
            [classes$11.buttonTransition, classes$11.ajaxCartToggle].join(" ")
          )
          .attr("aria-label", theme.strings.addToCart),
          $primaryButtonText.attr("aria-hidden", !1),
          $secondaryButtonText.attr("aria-hidden", !0),
          $notification
            .removeClass(classes$11.productNotificationError)
            .removeClass(classes$11.productNotificationSuccess)
            .text("")
            .attr("role", "");
      },
      _updateOnlineStatus: function () {
        theme.isOnline = !0;
      },
      _updateOfflineStatus: function () {
        theme.isOnline = !1;
      },
      getBaseUnit: function (variant) {
        return variant.unit_price_measurement.reference_value === 1
          ? variant.unit_price_measurement.reference_unit
          : variant.unit_price_measurement.reference_value +
              variant.unit_price_measurement.reference_unit;
      },
    },
    types = { link: "link", script: "script" },
    status = { requested: "requested", loaded: "loaded" },
    cloudCdn = "https://cdn.shopify.com/shopifycloud/",
    libraries = {
      plyrShopifyStyles: {
        tagId: "plyr-shopify-styles",
        src: cloudCdn + "shopify-plyr/v1.0/shopify-plyr.css",
        type: types.link,
      },
      modelViewerUiStyles: {
        tagId: "shopify-model-viewer-ui-styles",
        src: cloudCdn + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
        type: types.link,
      },
    },
    libraryLoader = {
      load: function (libraryName, callback) {
        var library = libraries[libraryName];
        if (library && library.status !== status.requested) {
          if (
            ((callback = callback || function () {}),
            library.status === status.loaded)
          ) {
            callback();
            return;
          }
          library.status = status.requested;
          var tag;
          switch (library.type) {
            case types.script:
              tag = this._createScriptTag(library, callback);
              break;
            case types.link:
              tag = this._createLinkTag(library, callback);
              break;
          }
          (tag.id = library.tagId), (library.element = tag);
          var firstScriptTag = document.getElementsByTagName(library.type)[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }
      },
      _createScriptTag: function (library, callback) {
        var tag = document.createElement("script");
        return (
          (tag.src = library.src),
          tag.addEventListener("load", function () {
            (library.status = status.loaded), callback();
          }),
          tag
        );
      },
      _createLinkTag: function (library, callback) {
        var tag = document.createElement("link");
        return (
          (tag.href = library.src),
          (tag.rel = "stylesheet"),
          (tag.type = "text/css"),
          utils.promiseStylesheet(library.src).then(function () {
            (library.status = status.loaded), callback();
          }),
          tag
        );
      },
    },
    modelJsonSections = {},
    models = {},
    xrButtons = {},
    selectors$13 = {
      mediaGroup: "[data-media-group]",
      productMediaTypeModel: "[data-product-media-type-model]",
      xrButton: "[data-shopify-xr]",
    },
    attributes = {
      modelJson: "data-model-json",
      productSlideshowSlide: "data-product-slideshow-slide",
    },
    classes$12 = { slideActive: "slider__slide--active" },
    productModel = {
      initModelViewers: function ($sectionContainer) {
        utils.isTouch();
        var $container = $sectionContainer || this.$container,
          $modelViewerElements = $(
            selectors$13.productMediaTypeModel,
            $container
          ),
          $xrButtons = $(selectors$13.xrButton, $container);
        (!$xrButtons.length && !$modelViewerElements.length) ||
          this._initModelViewerLibraries($modelViewerElements);
      },
      removeSectionModels: function () {
        for (var key in models)
          if (models.hasOwnProperty(key)) {
            var model = models[key];
            model.sectionId === this.id &&
              (model.modelViewerUi.destroy(), delete models[key]);
          }
        delete modelJsonSections[this.id];
      },
      _initModelViewerLibraries: function (modelViewerContainers) {
        modelJsonSections[this.id] = { loaded: !1 };
        var sectionId = this.id;
        modelViewerContainers.each(function (index) {
          var $modelViewerContainer = $(this),
            mediaId = $modelViewerContainer.data("media-id"),
            $modelViewerElement = $(
              $modelViewerContainer.find("model-viewer")[0]
            ),
            modelId = $modelViewerElement.data("model-id");
          if (index === 0) {
            var $xrButton = $modelViewerContainer
              .closest(selectors$13.mediaGroup)
              .find(selectors$13.xrButton);
            xrButtons[sectionId] = { $element: $xrButton, defaultId: modelId };
          }
          models[mediaId] = {
            modelId,
            sectionId,
            $container: $modelViewerContainer,
            $element: $modelViewerElement,
          };
        }),
          window.Shopify.loadFeatures([
            {
              name: "shopify-xr",
              version: "1.0",
              onLoad: this._setupShopifyXr.bind(this),
            },
          ]),
          modelViewerContainers.length &&
            (window.Shopify.loadFeatures([
              {
                name: "model-viewer-ui",
                version: "1.0",
                onLoad: this._setupModelViewerUi.bind(this),
              },
            ]),
            libraryLoader.load("modelViewerUiStyles"));
      },
      _setupShopifyXr: function (errors2) {
        if (!errors2) {
          if (!window.ShopifyXR) {
            document.addEventListener(
              "shopify_xr_initialized",
              function () {
                this._setupShopifyXr();
              }.bind(this)
            );
            return;
          }
          for (var sectionId in modelJsonSections)
            if (modelJsonSections.hasOwnProperty(sectionId)) {
              var modelSection = modelJsonSections[sectionId];
              if (modelSection.loaded) continue;
              var $modelJson = $(
                "[" + attributes.modelJson + '="' + sectionId + '"]'
              );
              window.ShopifyXR.addModels(JSON.parse($modelJson.html())),
                (modelSection.loaded = !0);
            }
          window.ShopifyXR.setupXRElements();
        }
      },
      _setupModelViewerUi: function (errors2) {
        if (!errors2) {
          for (var key in models)
            if (models.hasOwnProperty(key)) {
              var model = models[key];
              model.modelViewerUi ||
                (model.modelViewerUi = new Shopify.ModelViewerUI(
                  model.$element,
                  { iconUrl: theme.modelViewerUiSprite }
                )),
                this._setupModelViewerListeners(model);
            }
        }
      },
      updateShopifyXr: function (sectionId, currentMediaId) {
        var xrButton = xrButtons[sectionId];
        if (xrButton) {
          var modelId = currentMediaId
            ? models[currentMediaId].modelId
            : xrButton.defaultId;
          xrButton.$element.attr("data-shopify-model3d-id", modelId);
        }
      },
      _setupModelViewerListeners: function (model) {
        var $mediaSlide = model.$container,
          $isSlideshow = $mediaSlide[0].hasAttribute(
            attributes.productSlideshowSlide
          );
        $isSlideshow &&
          (model.$element
            .on("shopify_model_viewer_ui_toggle_play", function () {
              $mediaSlide.hasClass(classes$12.slideActive) &&
                $mediaSlide.trigger("mediaSlideIsDraggable", [!1]);
            })
            .on("shopify_model_viewer_ui_toggle_pause", function () {
              $mediaSlide.hasClass(classes$12.slideActive) &&
                $mediaSlide.trigger("mediaSlideIsDraggable", [!0]);
            }),
          model.$container.on("mediaVisible", function () {
            utils.isTouch() || model.modelViewerUi.play();
          }),
          model.$container
            .on("mediaHidden", function () {
              model.modelViewerUi.pause();
            })
            .on("xrLaunch", function () {
              model.modelViewerUi.pause();
            }));
      },
    },
    promiseYoutubeAPI,
    youtube = {
      promiseAPI: function () {
        if (!promiseYoutubeAPI) {
          var tag = document.createElement("script");
          tag.src = "https://www.youtube.com/iframe_api";
          var firstScriptTag = document.getElementsByTagName("script")[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag),
            (promiseYoutubeAPI = $.Deferred(function (defer) {
              (window.onYouTubeIframeAPIReady = defer.resolve),
                setTimeout(function () {
                  defer.reject(
                    "Request for YouTube API timed out after 30 seconds."
                  );
                }, 3e4);
            }));
        }
        return promiseYoutubeAPI;
      },
      promisePlayer: function (id, options) {
        return this.promiseAPI().then(function () {
          return $.Deferred(function (defer) {
            typeof window.YT > "u" &&
              defer.reject(
                "We're sorry, something went wrong. The YouTube API has not loaded correctly."
              );
            var player = new YT.Player(id, options);
            player.addEventListener("onReady", function () {
              defer.resolve(player);
            }),
              setTimeout(function () {
                defer.reject(
                  "Request for YouTube player has timed out after 30 seconds."
                );
              }, 3e4);
          });
        });
      },
    },
    videos = {},
    hosts = { html5: "html5", youtube: "youtube" },
    selectors$14 = {
      productMediaWrapper: "[data-product-media-wrapper]",
      productMediaTypeVideo: "[data-product-media-type-video]",
    },
    attributes$1 = {
      enableVideoLooping: "enable-video-looping",
      videoId: "video-id",
      productMediaSlide: "data-product-slideshow-slide",
    },
    productVideo = {
      initProductVideos: function ($sectionContainer) {
        utils.isTouch();
        var $container = $sectionContainer || this.$container;
        $(selectors$14.productMediaTypeVideo, $container).each(
          function (index, video) {
            var $videoElement = $(video);
            this._setupProductVideo($videoElement);
          }.bind(this)
        );
      },
      removeSectionVideos: function (sectionId) {
        for (var key in videos)
          if (videos.hasOwnProperty(key)) {
            var video = videos[key];
            video.sectionId === sectionId &&
              (video.player && video.player.destroy(), delete videos[key]);
          }
      },
      _setupProductVideo: function ($videoContainer) {
        if ($videoContainer.length) {
          var videoElement = $videoContainer.find("iframe, video")[0],
            mediaId = $videoContainer.data("media-id"),
            self = this;
          if (videoElement) {
            videos[mediaId] = {
              mediaId,
              sectionId: self.id,
              host: self._hostFromVideoElement(videoElement),
              $container: $videoContainer,
              element: videoElement,
              ready: function () {
                self._createPlayer(this);
              },
            };
            var video = videos[mediaId];
            switch (video.host) {
              case hosts.html5:
                window.Shopify.loadFeatures([
                  {
                    name: "video-ui",
                    version: "1.1",
                    onLoad: this._setupPlyrVideos.bind(this),
                  },
                ]),
                  libraryLoader.load("plyrShopifyStyles");
                break;
              case hosts.youtube:
                this._loadVideos(hosts.youtube);
                break;
            }
          }
        }
      },
      _setupPlyrVideos: function (errors2) {
        if (errors2) {
          this._fallbackToNativeVideo();
          return;
        }
        this._loadVideos(hosts.html5);
      },
      _createPlayer: function (video) {
        if (!video.player) {
          var $productMediaWrapper = video.$container.closest(
              selectors$14.productMediaWrapper
            ),
            isSlideshow = $($productMediaWrapper)[0].hasAttribute(
              attributes$1.productMediaSlide
            ),
            enableLooping = $productMediaWrapper.data(
              attributes$1.enableVideoLooping
            );
          switch (video.host) {
            case hosts.html5:
              (video.player = new Shopify.Plyr(video.element, {
                loop: { active: enableLooping },
                iconUrl: theme.plyrSprite,
              })),
                isSlideshow &&
                  (video.player.on("seeking", function () {
                    $productMediaWrapper.trigger("mediaSlideIsDraggable", [!1]);
                  }),
                  video.player.on(
                    "seeked",
                    debounce(function () {
                      $productMediaWrapper.trigger("mediaSlideIsDraggable", [
                        !0,
                      ]);
                    }, 1e3)
                  ));
              break;
            case hosts.youtube:
              var videoId = $productMediaWrapper.data(attributes$1.videoId);
              if (video.requested) return;
              (video.requested = !0),
                youtube
                  .promisePlayer(video.element, {
                    videoId,
                    events: {
                      onStateChange: function (event) {
                        event.data === 0 &&
                          enableLooping &&
                          event.target.seekTo(0);
                      },
                    },
                  })
                  .then(function (player) {
                    video.player = player;
                  })
                  .catch(function (error) {
                    console.error(error);
                  });
              break;
          }
          $productMediaWrapper.on("mediaHidden xrLaunch", function () {
            video.player &&
              (video.host === hosts.html5 && video.player.pause(),
              video.host === hosts.youtube &&
                video.player.pauseVideo &&
                video.player.pauseVideo());
          }),
            $productMediaWrapper.on("mediaVisible", function () {
              utils.isTouch() ||
                (video.player &&
                  (video.host === hosts.html5 && video.player.play(),
                  video.host === hosts.youtube &&
                    video.player.playVideo &&
                    video.player.playVideo()));
            });
        }
      },
      _hostFromVideoElement: function (video) {
        return video.tagName === "VIDEO"
          ? hosts.html5
          : video.tagName === "IFRAME" &&
            /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
              video.src
            )
          ? hosts.youtube
          : null;
      },
      _loadVideos: function (host) {
        for (var key in videos)
          if (videos.hasOwnProperty(key)) {
            var video = videos[key];
            video.host === host && video.ready();
          }
      },
      _fallbackToNativeVideo: function () {
        for (var key in videos)
          if (videos.hasOwnProperty(key)) {
            var video = videos[key];
            if (video.nativeVideo) continue;
            video.host === hosts.html5 &&
              (video.element.setAttribute("controls", "controls"),
              (video.nativeVideo = !0));
          }
      },
    },
    selectors$11 = {
      socialSharing: ".social-sharing",
      detailsButton: ".product__more-details",
    };
  sections.register("featured-product", {
    onLoad: function () {
      this.extend(socialSharing),
        this.extend(productDisplay),
        this.extend(productModel),
        this.extend(productVideo),
        this.initModelViewers(),
        this.initProductVideos(),
        this.on("variant_change", this._updateProductLink.bind(this)),
        this.window().on(
          "resize",
          debounce(this._formatVariantSelectors.bind(this), 500)
        );
    },
    _updateProductLink: function (evt, instance, product2, variant) {
      var $link = $(selectors$11.detailsButton, this.$container),
        url = utils.updateUrlParameter(
          $link.attr("href"),
          "variant",
          variant.id
        );
      $link.attr("href", url);
    },
    onUnload: function () {
      this.removeSectionVideos(this.id), this.removeSectionModels(this.id);
    },
  });
  var selectors$16 = {
      slides: ".slider__slide",
      activeSlide: ".slider__slide--active",
    },
    classes$14 = {
      activeSlide: "slider__slide--active",
      previousSlide: "slider__slide--previous",
      nextSlide: "slider__slide--next",
      transitioningSlide: "slider__slide--transitioning",
      draggingSlide: "slider__slide--dragging",
    },
    events = {
      nextSlide: "nextslide",
      prevSlide: "prevslide",
      transitionStart: "slidetransitionstart",
      transitionEnd: "slidetransitionend",
    },
    defaults = { moveThreshold: 25 };
  function Slider(element, settings2) {
    (this.$element = $(element)),
      (this.$slides = $(selectors$16.slides, this.$element)),
      (this.config = $.extend({}, defaults, settings2)),
      (this.isDraggable = !0),
      this._setCurrentSlide($(selectors$16.activeSlide, this.$element)),
      this._assignTouchHandlers(),
      (this.bindedOnFocus = this._onFocus.bind(this)),
      (this.bindedOnBlur = this._onBlur.bind(this)),
      this.$slides.length &&
        (this.$slides[0].addEventListener("focus", this.bindedOnFocus, !0),
        this.$slides[0].addEventListener("blur", this.bindedOnBlur, !0));
  }
  Slider.prototype = $.extend({}, Slider.prototype, {
    destroy: function () {
      return (
        this.$element.off("touchstart mousedown"),
        this.$slides.length &&
          (this.$slides[0].removeEventListener("focus", this.bindedOnFocus, !0),
          this.$slides[0].removeEventListener("blur", this.bindedOnBlur, !0)),
        null
      );
    },
    nextSlide: function () {
      return (
        this._triggerEvent([events.nextSlide, events.transitionStart]),
        this._promiseNextSlide().then(
          function () {
            this._triggerEvent(events.transitionEnd);
          }.bind(this)
        )
      );
    },
    previousSlide: function () {
      return (
        this._triggerEvent([events.prevSlide, events.transitionStart]),
        this._promisePrevSlide().then(
          function () {
            this._triggerEvent(events.transitionEnd);
          }.bind(this)
        )
      );
    },
    setSlide: function (setIndex, animate) {
      var slidePromiseChain = this.slidePromiseChain || $.Deferred().resolve(),
        currentIndex = this.$currentSlide.index(),
        totalSlides = this.$slides.length,
        promiseSlide = $.Deferred().resolve();
      return (
        (this.slidePromiseChain = slidePromiseChain.then(
          function () {
            return (
              setIndex < totalSlides &&
                setIndex !== currentIndex &&
                (animate
                  ? setIndex > currentIndex
                    ? (promiseSlide = utils.promiseRepeatSeries(
                        this.nextSlide.bind(this),
                        setIndex - currentIndex
                      ))
                    : setIndex < currentIndex &&
                      (promiseSlide = utils.promiseRepeatSeries(
                        this.previousSlide.bind(this),
                        currentIndex - setIndex
                      ))
                  : (promiseSlide = this._promiseSlide(
                      this.$slides.eq(setIndex)
                    ))),
              promiseSlide
            );
          }.bind(this)
        )),
        this.slidePromiseChain
      );
    },
    setIsDraggable: function (isDraggable) {
      this.isDraggable = isDraggable;
    },
    shouldPreventSlide: function (target, selectors2, slideCount) {
      return !!(
        slideCount < 2 || $(target).closest(selectors2.join(",")).length
      );
    },
    _promiseNextSlide: function () {
      return (
        requestAnimationFrame(
          function () {
            this.$nextSlide.addClass(classes$14.nextSlide),
              requestAnimationFrame(
                function () {
                  this.$slides.removeAttr("style"),
                    this.$nextSlide
                      .removeClass(classes$14.nextSlide)
                      .addClass(classes$14.activeSlide)
                      .addClass(classes$14.transitioningSlide),
                    this.$currentSlide
                      .removeClass(classes$14.activeSlide)
                      .addClass(classes$14.previousSlide)
                      .addClass(classes$14.transitioningSlide);
                }.bind(this)
              );
          }.bind(this)
        ),
        this._promiseSlideTransitionEnd().then(
          function () {
            this._setCurrentSlide(this.$nextSlide);
          }.bind(this)
        )
      );
    },
    _promisePrevSlide: function () {
      return (
        requestAnimationFrame(
          function () {
            this.$previousSlide.addClass(classes$14.previousSlide),
              requestAnimationFrame(
                function () {
                  this.$slides.removeAttr("style"),
                    this.$previousSlide
                      .removeClass(classes$14.previousSlide)
                      .addClass(classes$14.activeSlide)
                      .addClass(classes$14.transitioningSlide),
                    this.$currentSlide
                      .removeClass(classes$14.activeSlide)
                      .addClass(classes$14.nextSlide)
                      .addClass(classes$14.transitioningSlide);
                }.bind(this)
              );
          }.bind(this)
        ),
        this._promiseSlideTransitionEnd().then(
          function () {
            this._setCurrentSlide(this.$previousSlide);
          }.bind(this)
        )
      );
    },
    _promiseSlide: function ($slide) {
      return (
        this._setCurrentSlide($slide),
        $slide
          .addClass(classes$14.activeSlide)
          .siblings()
          .removeClass(classes$14.activeSlide),
        $.Deferred(
          function (defer) {
            requestAnimationFrame(
              function () {
                this._triggerEvent(events.transitionEnd), defer.resolve();
              }.bind(this)
            );
          }.bind(this)
        )
      );
    },
    _promiseCancelSlide: function () {
      return (
        requestAnimationFrame(
          function () {
            this.$slides
              .removeAttr("style")
              .addClass(classes$14.transitioningSlide);
          }.bind(this)
        ),
        this._promiseSlideTransitionEnd()
      );
    },
    _promiseSlideTransitionEnd: function () {
      return $.Deferred(
        function (defer) {
          this.$currentSlide.one(
            "transitionend",
            function () {
              this.$slides.removeClass(
                [
                  classes$14.transitioningSlide,
                  classes$14.nextSlide,
                  classes$14.previousSlide,
                ].join(" ")
              ),
                defer.resolve();
            }.bind(this)
          );
        }.bind(this)
      );
    },
    _setCurrentSlide: function ($slide) {
      (this.$currentSlide = $slide),
        (this.$nextSlide = this._nextSlideIndex($slide, this.$slides)),
        (this.$previousSlide = this._prevSlideIndex($slide, this.$slides));
    },
    _assignTouchHandlers: function () {
      (this.bindedTouchStart = this._onTouchStart.bind(this)),
        (this.bindedTouchMove = this._onTouchMove.bind(this)),
        (this.bindedTouchEnd = this._onTouchEnd.bind(this)),
        this.$element
          .one("touchstart", this.bindedTouchStart)
          .one("mousedown", this.bindedTouchStart);
    },
    _onTouchStart: function (evt) {
      (this.windowWidth = $(window).innerWidth()),
        (this.startPosition = utils.pointerEventToXY(evt)),
        (this.isDragging = !1),
        this.$element
          .on("touchmove mousemove", this.bindedTouchMove)
          .on("touchend mouseup", this.bindedTouchEnd);
    },
    _onTouchMove: function (evt) {
      this.isDraggable &&
        ((this.currentPosition = utils.pointerEventToXY(evt)),
        (this.percentMoved =
          ((this.currentPosition.x - this.startPosition.x) / this.windowWidth) *
          100),
        this.isDragging || (this.isDragging = !0),
        this.percentMoved > 0
          ? (this.$previousSlide.addClass(classes$14.previousSlide),
            this.$nextSlide.removeClass(classes$14.nextSlide),
            this.$previousSlide.css({
              transform: "translateX(" + (this.percentMoved - 100) + "%)",
            }))
          : (this.$previousSlide.removeClass(classes$14.previousSlide),
            this.$nextSlide.addClass(classes$14.nextSlide),
            this.$nextSlide.css({
              transform: "translateX(" + (100 + this.percentMoved) + "%)",
            })),
        this.$currentSlide
          .addClass(classes$14.draggingSlide)
          .css({ transform: "translateX(" + this.percentMoved + "%)" }));
    },
    _onTouchEnd: function () {
      var moveThreshold = this.config.moveThreshold,
        promiseTransition = $.Deferred().resolve();
      this.$element.off(),
        this.isDragging &&
          ((this.isDragging = !1),
          this.$currentSlide.removeClass(classes$14.draggingSlide),
          this.percentMoved > moveThreshold
            ? (promiseTransition = this.previousSlide())
            : this.percentMoved < -moveThreshold
            ? (promiseTransition = this.nextSlide())
            : (promiseTransition = this._promiseCancelSlide())),
        promiseTransition.then(
          function () {
            this.$element
              .one("touchstart", this.bindedTouchStart)
              .one("mousedown", this.bindedTouchStart);
          }.bind(this)
        );
    },
    _onFocus: function () {
      this.$element.one("keyup", this._onKeyup.bind(this));
    },
    _onBlur: function () {
      this.$element.off("keyup");
    },
    _onKeyup: function (evt) {
      var promiseTransition = $.Deferred().resolve(),
        refocusOnSlideShow = !1,
        shouldPreventSlide = this.shouldPreventSlide(
          evt.target,
          [".plyr", ".shopify-model-viewer-ui"],
          this.$slides.length
        );
      switch (evt.keyCode) {
        case 37:
          if (shouldPreventSlide) break;
          (promiseTransition = this.previousSlide()),
            (refocusOnSlideShow = $.contains(
              this.$element[0],
              document.activeElement
            ));
          break;
        case 39:
          if (shouldPreventSlide) break;
          (promiseTransition = this.nextSlide()),
            (refocusOnSlideShow = $.contains(
              this.$element[0],
              document.activeElement
            ));
          break;
      }
      promiseTransition.then(
        function () {
          refocusOnSlideShow && this.$element.focus(),
            this.$element.one("keyup", this._onKeyup.bind(this));
        }.bind(this)
      );
    },
    _triggerEvent: function (names) {
      typeof names == "string" && (names = [names]),
        names.forEach(
          function (name) {
            this.$element.trigger(name, {
              $previousSlide: this.$previousSlide,
              $currentSlide: this.$currentSlide,
              $nextSlide: this.$nextSlide,
            });
          }.bind(this)
        );
    },
    _nextSlideIndex: function ($current, $slides) {
      var index = $current.index(),
        count = $slides.length,
        next = index + 1;
      return index + 1 === count && (next = 0), $slides.eq(next);
    },
    _prevSlideIndex: function ($current, $slides) {
      var index = $current.index(),
        count = $slides.length,
        prev = index - 1;
      return index - 1 === -1 && (prev = count - 1), $slides.eq(prev);
    },
  });
  var selectors$15 = {
      coverTopBackground: ".reveal-slider__cover-background--top",
      coverBottomBackground: ".reveal-slider__cover-background--bottom",
      coverContent: ".reveal-slider__cover-content",
      slideNavButtons: ".reveal-slider__nav-button",
      slidePreviousButton: ".reveal-slider__previous-button",
      slideNextButton: ".reveal-slider__next-button",
      closeCoverButton: ".reveal-slider__close",
      slider: ".slider",
    },
    classes$13 = { navButtonActive: "active", coverOpen: "open" },
    revealSlider = {
      initRevealSlider: function () {
        this.trigger("reveal_slider_init_start"),
          (this.revealSlider = !0),
          (this.coverIsOpen = !1),
          (this.revealSliderNamespace = ".revealSlider"),
          (this.mediaQuerySmall = theme.mediaQuerySmall),
          (this.slider = new Slider($(selectors$15.slider, this.$container))),
          (this.hammertime = new Hammer2(this.$container[0])),
          this.on(
            "click",
            selectors$15.slideNavButtons,
            this._onClickNavButton.bind(this)
          ),
          this.on(
            "click",
            selectors$15.slidePreviousButton,
            this.slider.previousSlide.bind(this.slider)
          ),
          this.on(
            "click",
            selectors$15.slideNextButton,
            this.slider.nextSlide.bind(this.slider)
          ),
          this.on(
            "click",
            selectors$15.closeCoverButton,
            this.closeCover.bind(this)
          ),
          this.on(
            "click",
            selectors$15.coverContent,
            this.openCover.bind(this)
          ),
          this.on(
            "nextslide prevslide",
            this._changeBackgroundColor.bind(this)
          ),
          this.on("slidetransitionend", this._onSlideTransitionEnd.bind(this)),
          this.document().on(
            "touchstart" + this.revealSliderNamespace,
            this._onTouchStart.bind(this)
          ),
          this.document().on(
            "touchend" + this.revealSliderNamespace,
            this._onTouchEnd.bind(this)
          ),
          this.hammertime
            .on("pinchout pinchin", this._onPinch.bind(this))
            .on("pinchend pinchcancel", this._onPinchEnd.bind(this)),
          this.trigger("reveal_slider_init_done");
      },
      destroyRevealSlider: function () {
        (this.revealSlider = !1),
          (this.slider = this.slider.destroy()),
          this.document().off(this.revealSliderNamespace),
          this.off(),
          this.trigger("reveal_slider_destroy");
      },
      openCover: function () {
        this.$container.addClass(classes$13.coverOpen),
          (this.coverIsOpen = !0),
          this.trigger("reveal_slider_open_cover");
      },
      closeCover: function () {
        this.$container.removeClass(classes$13.coverOpen),
          (this.coverIsOpen = !1),
          this.trigger("reveal_slider_close_cover");
      },
      _changeBackgroundColor: function (evt, data2) {
        var color;
        evt.type === "nextslide"
          ? (color = data2.$nextSlide.data("background-color"))
          : (color = data2.$previousSlide.data("background-color")),
          $(selectors$15.slider, this.$container).css({
            backgroundColor: color,
          });
      },
      _onSlideTransitionEnd: function (evt, data2) {
        var index = data2.$currentSlide.index();
        $(selectors$15.slideNavButtons, this.$container)
          .eq(index)
          .addClass(classes$13.navButtonActive)
          .siblings()
          .removeClass(classes$13.navButtonActive);
      },
      _onClickNavButton: function (evt) {
        var $navButton = $(evt.target),
          index = $navButton.index();
        this.slider.setSlide($navButton.index()),
          this.trigger("reveal_slider_set_slide", [index]);
      },
      _onTouchStart: function (evt) {
        evt.originalEvent.touches.length <= 1 ||
          ((this.enablePinch = !0),
          this.hammertime.get("pinch").set({ enable: this.enablePinch }));
      },
      _onTouchEnd: function () {
        this.enablePinch &&
          ((this.enablePinch = !1),
          this.hammertime.get("pinch").set({ enable: this.enablePinch }));
      },
      _onPinch: function (evt) {
        (this.$coverTopBackground =
          this.$coverTopBackground ||
          $(selectors$15.coverTopBackground, this.$container)),
          (this.$coverBottomBackground =
            this.$coverBottomBackground ||
            $(selectors$15.coverBottomBackground, this.$container)),
          (this.$coverTitle =
            this.$coverTitle || $(selectors$15.coverContent, this.$container)),
          !(
            (evt.type === "pinchin" && !this.coverIsOpen) ||
            (evt.type === "pinchout" && this.coverIsOpen)
          ) &&
            ((this.distance = this.coverIsOpen
              ? 70 * evt.scale
              : (evt.scale - 1) * 25),
            this.distance < 0 && (this.distance = 0),
            this.$coverBottomBackground.css({
              transform: "translateY(" + this.distance + "%)",
            }),
            this.$coverTopBackground.css({
              transform: "translateY(-" + this.distance + "%)",
            }),
            this.$coverTitle.css({ opacity: 1 - this.distance / 30 }));
      },
      _onPinchEnd: function (evt) {
        evt.scale > 2
          ? (this.$container.addClass(classes$13.coverOpen),
            (this.coverIsOpen = !0))
          : (this.$container.removeClass(classes$13.coverOpen),
            (this.coverIsOpen = !1)),
          requestAnimationFrame(
            function () {
              this.$coverTopBackground.removeAttr("style"),
                this.$coverBottomBackground.removeAttr("style"),
                this.$coverTitle.removeAttr("style");
            }.bind(this)
          );
      },
    },
    selectors$17 = {
      coverContent: ".side-scroller__cover-content",
      slidesContainer: ".side-scroller__slides-container",
      coverBackground: ".side-scroller__cover-background",
      slides: ".side-scroller__slide",
    },
    classes$15 = {
      coverFixed: "side-scroller--fixed",
      coverBottom: "side-scroller--fixed-bottom",
    },
    sideScroller = {
      initSideScroller: function () {
        this.trigger("side_scroller_init_start"),
          (this.$slides = $(selectors$17.slides, this.$container)),
          (this.$slidesContainer = $(
            selectors$17.slidesContainer,
            this.$container
          )),
          (this.sideScroller = !0),
          (this.sideScrollerNamespace = ".sideScroller"),
          (this.coverPosition = "top"),
          this.window().on(
            "scroll" + this.sideScrollerNamespace,
            this._onScroll.bind(this)
          ),
          this.window().on(
            "resize" + this.sideScrollerNamespace,
            this._updateCoverPositionValues.bind(this)
          ),
          this.window().on(
            "resize" + this.sideScrollerNamespace,
            this._onScroll.bind(this)
          ),
          this.document().on(
            "drawer_open_start" + this.sideScrollerNamespace,
            this._handleFixedSideImage.bind(this)
          ),
          this.document().on(
            "drawer_close_done" + this.sideScrollerNamespace,
            this._resetFixedSideImage.bind(this)
          ),
          utils.promiseStylesheet().then(
            function () {
              this._updateCoverPositionValues(),
                this._onScroll(),
                this.trigger("side_scroller_init_done");
            }.bind(this)
          );
      },
      destroySideScroller: function () {
        (this.sideScroller = !1),
          this.window().off(this.sideScrollerNamespace),
          this.document().off(this.sideScrollerNamespace),
          this.trigger("side_scroller_destroy");
      },
      _handleFixedSideImage: function () {
        if (this.coverPosition === "fixed") {
          var $coverContent = $(selectors$17.coverContent, this.$container),
            coverContentHeight = $coverContent.outerHeight(),
            scrollTop = $(window).scrollTop(),
            translate = scrollTop - this.featuresOffset.top;
          $(selectors$17.coverBackground, this.$container).css({
            transform: "translateY(" + translate + "px)",
            position: "absolute",
          }),
            $(selectors$17.coverContent, this.$container).css({
              transform:
                "translate(-50%, " +
                (translate - coverContentHeight / 2) +
                "px)",
              position: "absolute",
            });
        }
      },
      _resetFixedSideImage: function () {
        this.coverPosition === "fixed" &&
          $(selectors$17.coverBackground, this.$container)
            .add(selectors$17.coverContent, this.$container)
            .css({ transform: "", position: "" });
      },
      _onScroll: function () {
        var scrollTop = $(window).scrollTop();
        scrollTop > this.featuresOffset.top &&
        scrollTop + this.windowHeight <=
          this.featuresOffset.top + this.featuresHeight
          ? (requestAnimationFrame(this._setCoverPosition.bind(this, "fixed")),
            requestAnimationFrame(
              this._updateBackgroundColor.bind(this, scrollTop)
            ))
          : scrollTop + this.windowHeight >
            this.featuresOffset.top + this.featuresHeight
          ? requestAnimationFrame(this._setCoverPosition.bind(this, "bottom"))
          : requestAnimationFrame(this._setCoverPosition.bind(this, "top"));
      },
      _setCoverPosition: function (position) {
        if (this.coverPosition !== position)
          switch (position) {
            case "top":
              this.$container.removeClass(
                [classes$15.coverBottom, classes$15.coverFixed].join(" ")
              ),
                this.trigger("side_scroller_position_top");
              break;
            case "fixed":
              this.$container
                .removeClass(classes$15.coverBottom)
                .addClass(classes$15.coverFixed),
                this.trigger("side_scroller_position_fixed");
              break;
            case "bottom":
              this.$container
                .removeClass(classes$15.coverFixed)
                .addClass(classes$15.coverBottom),
                this.trigger("side_scroller_position_bottom");
              break;
          }
        this.coverPosition = position;
      },
      _updateBackgroundColor: function (scrollTop) {
        var currentSlideIndex = Math.floor(
          (scrollTop - this.featuresOffset.top + this.windowHeight / 2) /
            this.slideHeight
        );
        (this.currentBackgroundIndex = this.currentBackgroundIndex || 0),
          currentSlideIndex !== this.currentBackgroundIndex &&
            ((this.currentBackgroundIndex = currentSlideIndex),
            this.$slidesContainer.css({
              backgroundColor: this.$slides
                .eq(currentSlideIndex)
                .data("background-color"),
            }));
      },
      _updateCoverPositionValues: function () {
        (this.slideHeight = this.$slides.first().height()),
          (this.featuresOffset = this.$container.offset()),
          (this.featuresHeight = this.$container.height()),
          (this.windowHeight = $(window).innerHeight()),
          (this.windowWidth = $(window).innerWidth());
      },
    };
  sections.register("featured-slider", {
    onLoad: function () {
      (this.coverIsOpen = !1),
        this.extend(revealSlider),
        this.extend(sideScroller),
        this._toggleViewState(),
        $(window).on("resize", debounce(this._toggleViewState.bind(this)));
    },
    onUnload: function () {
      this._destroyDesktopState(), this._destroyMobileState();
    },
    onDeselect: function () {
      this.mobileViewEnabled && this.closeCover();
    },
    onBlockSelect: function (evt) {
      this.mobileViewEnabled
        ? (this.openCover(), this.slider.setSlide($(evt.target).index()))
        : $("html, body").animate(
            { scrollTop: $(evt.target).offset().top },
            400
          );
    },
    onBlockDeselect: function () {
      this.mobileViewEnabled && this.revealSlider.closeCover();
    },
    _toggleViewState: function () {
      var windowWidth = $(window).innerWidth(),
        enableMobileView,
        enableDesktopView;
      typeof this.mobileViewEnabled > "u"
        ? ((enableMobileView = windowWidth < theme.mediaQuerySmall),
          (enableDesktopView = windowWidth >= theme.mediaQuerySmall))
        : ((enableMobileView =
            windowWidth < theme.mediaQuerySmall && !this.mobileViewEnabled),
          (enableDesktopView =
            windowWidth >= theme.mediaQuerySmall && this.mobileViewEnabled)),
        enableMobileView &&
          ((this.mobileViewEnabled = !0),
          this._destroyDesktopState(),
          this._enableMobileState()),
        enableDesktopView &&
          ((this.mobileViewEnabled = !1),
          this._destroyMobileState(),
          this._enableDesktopState());
    },
    _enableDesktopState: function () {
      this.initSideScroller();
    },
    _destroyDesktopState: function () {
      typeof this.sideScroller < "u" && this.destroySideScroller();
    },
    _enableMobileState: function () {
      this.initRevealSlider();
    },
    _destroyMobileState: function () {
      this.revealSlider && this.destroyRevealSlider();
    },
  });
  var classes$16 = { footerParallax: "site-footer--parallax" },
    selectors$18 = {
      contentForLayout: ".content-for-layout",
      footerCover: ".site-footer__drawer-cover ",
    };
  sections.register("footer", {
    onLoad: function () {
      !this.container.hasAttribute("data-footer-parallax") ||
        ($("html").hasClass("is-ios") && Shopify.designMode) ||
        (this.window().on("resize", this._setParallax.bind(this)),
        this.document().on(
          "drawer_open_start",
          this._handleDrawerOpenState.bind(this)
        ),
        this.document().on(
          "drawer_close_done",
          this._resetDrawerOpenState.bind(this)
        ),
        $(document.body).addClass(classes$16.footerParallax),
        utils.promiseStylesheet().then(this._setParallax.bind(this)));
    },
    onUnload: function () {
      $(document.body).removeClass(classes$16.footerParallax),
        $(selectors$18.contentForLayout).css("margin-bottom", "");
    },
    _setParallax: function () {
      (this.height = this.$container.innerHeight()),
        $(selectors$18.contentForLayout).css("margin-bottom", this.height);
    },
    _handleDrawerOpenState: function () {
      if (document.body.scrollHeight - window.innerHeight === 0)
        this.$container.css(
          "margin-bottom",
          document.body.clientHeight - document.body.scrollHeight
        );
      else {
        var distanceFromBottom =
            document.body.scrollHeight - window.innerHeight - window.scrollY,
          adjustFooter = distanceFromBottom - this.height;
        this.$container.css("margin-bottom", adjustFooter),
          $(selectors$18.footerCover).css("height", distanceFromBottom).show();
      }
    },
    _resetDrawerOpenState: function () {
      this.$container.css("margin-bottom", ""),
        $(selectors$18.footerCover).hide();
    },
  });
  var selectors$19 = {
      skipLink: ".skip-link",
      navigation: ".navigation",
      navAnimateElements: ".navigation__entrance-animation",
      cartBubble: ".site-header__cart-bubble",
      siteHeader: ".site-header",
      siteHeaderWrapper: ".site-header__wrapper",
      siteHeaderLogo: ".site-header__logo",
      siteHeaderCart: ".site-header__cart",
      siteNavigation: "[data-site-navigation]",
      navigationButton: "[data-navigation-button]",
      navigationExpandSublinks: ".navigation__expand-sublinks",
      navigationExpandChildSublinks:
        ".navigation__expand-sublinks--third-level",
      navigationSublinksContainer: ".navigation__sublinks-container",
      navigationSublink: ".navigation__sublink",
      navigationSublinks: ".navigation__sublinks",
      navigationChildSublinks: ".navigation__sublinks--third-level",
      navigationHasSublinks: ".navigation__has-sublinks",
      announcementBar: ".announcement-bar",
      announcementBarClose: ".announcement-bar__close",
      contentForLayout: ".content-for-layout",
    },
    classes$17 = {
      themeEditor: "theme-editor",
      headerFixed: "site-header--fixed",
      headerHomepage: "site-header--homepage",
      headerTransparent: "site-header--transparent",
      cartBubbleVisible: "site-header__cart-bubble--visible",
      bubblePulse: "bubble-pulse",
      drawerActive: "drawer--active",
      navigationExpandChildSublinks: "navigation__expand-sublinks--third-level",
      navigationOpen: "navigation-open",
      navigationOpenEditor: "navigation-open--editor",
      navigationTransitioning: "navigation--is-transitioning",
      navigationHasSublinksCollapsed: "navigation__has-sublinks--collapsed",
      navigationEntranceActive: "navigation__entrance-animation--active",
      siteHeaderWrapperTransitioning: "site-header__wrapper--transitioning",
      announcementBarVisible: "announcement-bar--visible",
    },
    sectionsWithTransparentHeader = ["slideshow-section", "gallery", "hero"],
    scrollHandler = !0,
    blockEditorEvents = !1,
    navigationManuallyToggled = !1;
  sections.register("header-section", {
    onLoad: function () {
      (this.$container = $(this.container)),
        (this.$siteHeader = $(selectors$19.siteHeader)),
        (this.$siteHeaderWrapper = $(selectors$19.siteHeaderWrapper)),
        (this.scrollTop = 0),
        (this.isFixed = !1),
        (this.headerHeight = 0),
        (this.promiseChain = $.Deferred().resolve()),
        this._updateHeaderTransparency(),
        utils.disableTabbingOfChildren(selectors$19.navigation),
        $(selectors$19.navigationButton)
          .one("click", this._toggleNavigationDisplay.bind(this))
          .one("click", this._setSublinksMaxHeight.bind(this)),
        $(selectors$19.navigationExpandSublinks, this.$container).on(
          "click",
          this._toggleNavigationSublinks.bind(this)
        ),
        $(selectors$19.announcementBarClose, this.$container).on(
          "click",
          this._closeAnnouncementBar.bind(this)
        ),
        $("html").hasClass("is-ios") && Shopify.designMode
          ? (this.$siteHeader.removeClass(classes$17.headerHomepage),
            this.$siteHeader.removeClass(classes$17.headerTransparent))
          : $(document).on(
              "scroll" + this.namespace,
              throttle(this._toggleHeaderPosition.bind(this), 200)
            ),
        $(window).on(
          "resize" + this.namespace,
          this._adjustNavigationPadding.bind(this)
        ),
        $(document).on(
          "shopify:section:reorder shopify:section:load",
          this._updateHeaderTransparency.bind(this)
        ),
        $(document).on(
          "shopify:section:unload",
          function () {
            setTimeout(this._updateHeaderTransparency.bind(this));
          }.bind(this)
        ),
        cart.on("change", this._toggleCartBubble.bind(this)),
        utils.promiseStylesheet().then(
          function () {
            this._setupAnnouncementBar();
          }.bind(this)
        );
    },
    onSelect: function () {
      this._adjustNavigationPadding(),
        !navigationManuallyToggled &&
          ((blockEditorEvents = !0), this.showNavigation());
    },
    onDeselect: function () {
      (blockEditorEvents = !1),
        setTimeout(
          function () {
            blockEditorEvents ||
              ((navigationManuallyToggled = !1),
              (blockEditorEvents = !1),
              this.hideNavigation());
          }.bind(this),
          100
        );
    },
    _setupAnnouncementBar: function () {
      var $announcementBar = $(selectors$19.announcementBar, this.$container);
      $announcementBar.length &&
        ((utils.isSessionStorageSupported() &&
          sessionStorage.getItem("announcement-bar-hidden")) ||
          requestAnimationFrame(
            function () {
              $announcementBar.addClass(classes$17.announcementBarVisible),
                this.$siteHeaderWrapper.css(
                  "margin-top",
                  "-" + $announcementBar.outerHeight() + "px"
                ),
                requestAnimationFrame(
                  function () {
                    this.$siteHeaderWrapper
                      .addClass(classes$17.siteHeaderWrapperTransitioning)
                      .css("margin-top", "");
                  }.bind(this)
                );
            }.bind(this)
          ));
    },
    _closeAnnouncementBar: function (evt) {
      if ((evt.preventDefault(), !Shopify.designMode)) {
        var $announcementBar = $(selectors$19.announcementBar);
        this.$siteHeaderWrapper.css(
          "margin-top",
          "-" + $announcementBar.outerHeight() + "px"
        ),
          $(".main-content").css("margin-top", "0px"),
          $(selectors$19.announcementBarClose).attr("aria-expanded", !1),
          utils.isSessionStorageSupported() &&
            sessionStorage.setItem("announcement-bar-hidden", !0),
          utils.promiseTransitionEnd(this.$siteHeaderWrapper).then(
            function () {
              $announcementBar.remove(),
                this.$siteHeaderWrapper
                  .removeClass(classes$17.siteHeaderWrapperTransitioning)
                  .css("margin-top", "");
            }.bind(this)
          );
      }
    },
    _updateHeaderTransparency: function () {
      if (
        !($("html").hasClass("is-ios") && Shopify.designMode) &&
        (this.$siteHeader.removeClass(classes$17.headerTransparent),
        !!this.$siteHeader.data("transparent-header"))
      ) {
        var $firstSection = $(selectors$19.contentForLayout)
          .find("[data-section-type]")
          .first();
        !$firstSection.length ||
          sectionsWithTransparentHeader.indexOf(
            $firstSection.data("section-type")
          ) === -1 ||
          this.$siteHeader.addClass(classes$17.headerTransparent);
      }
    },
    _toggleHeaderPosition: function () {
      if (!(!scrollHandler || this.headerAnimating)) {
        var scrollTop = $(document).scrollTop();
        (this.headerHeight =
          this.headerHeight || this.$container.outerHeight()),
          scrollTop <= 0
            ? requestAnimationFrame(this._promiseHeaderReset.bind(this))
            : scrollTop < this.scrollTop &&
              scrollTop > 0 &&
              !this.isFixed &&
              !this.isAnimating
            ? requestAnimationFrame(this._promiseHeaderSlideIn.bind(this))
            : scrollTop > this.scrollTop &&
              scrollTop > this.headerHeight &&
              this.isFixed &&
              !this.isAnimating &&
              requestAnimationFrame(this._promiseHeaderSlideOut.bind(this)),
          (this.scrollTop = scrollTop),
          this._doubleCheckPosition();
      }
    },
    _doubleCheckPosition: function () {
      typeof this.doubleCheckDebounced > "u" &&
        (this.doubleCheckDebounced = debounce(
          function () {
            (this.scrollTop = $(document).scrollTop()),
              this.scrollTop <= 0 && this._promiseHeaderReset();
          }.bind(this),
          500
        )),
        this.doubleCheckDebounced();
    },
    _promiseHeaderReset: function () {
      this.promiseChain = this.promiseChain.then(
        function () {
          this.$container.removeClass(classes$17.headerFixed),
            $("body").css("padding-top", "");
        }.bind(this)
      );
    },
    _promiseHeaderSlideIn: function () {
      return (
        (this.isFixed = !0),
        (this.headerAnimating = !0),
        this.$siteHeaderWrapper.css("transform", "translateY(-100%)"),
        requestAnimationFrame(
          function () {
            this.$container.addClass(classes$17.headerFixed),
              this.$container.hasClass(classes$17.headerHomepage) ||
                $("body").css("padding-top", this.headerHeight),
              requestAnimationFrame(
                function () {
                  this.$siteHeaderWrapper.css({
                    transform: "translateY(0%)",
                    transition: "transform 0.25s ease-out",
                  });
                }.bind(this)
              );
          }.bind(this)
        ),
        utils.promiseTransitionEnd(this.$siteHeaderWrapper).then(
          function () {
            (this.headerAnimating = !1),
              this.$siteHeaderWrapper.attr("style", "");
          }.bind(this)
        )
      );
    },
    _promiseHeaderSlideOut: function () {
      return (
        (this.isFixed = !1),
        (this.headerAnimating = !0),
        this.$siteHeaderWrapper.css({
          transform: "translateY(-100%)",
          transition: "transform 0.25s ease-out",
        }),
        utils.promiseTransitionEnd(this.$siteHeaderWrapper).then(
          function () {
            (this.headerAnimating = !1),
              this.$siteHeaderWrapper.attr("style", ""),
              $("body").css("padding-top", ""),
              this.$container.removeClass(classes$17.headerFixed);
          }.bind(this)
        )
      );
    },
    _toggleCartBubble: function (evt, state) {
      var $bubble = $(selectors$19.cartBubble, this.$container);
      $bubble.toggleClass(
        classes$17.cartBubbleVisible,
        state.items.length !== 0
      ),
        $("body").hasClass(classes$17.drawerActive) ||
          ($bubble.addClass(classes$17.bubblePulse),
          utils.promiseAnimationEnd($bubble).then(function () {
            $bubble.removeClass(classes$17.bubblePulse);
          }));
    },
    showNavigation: function () {
      var isOpen = $(document.body).hasClass(classes$17.navigationOpen);
      this.siteNavigation = this.container.querySelector(
        selectors$19.siteNavigation
      );
      var navigationButton = this.siteNavigation.querySelector(
        selectors$19.navigationButton
      );
      return (
        isOpen ||
          ((scrollHandler = !1),
          this._adjustNavigationPadding(),
          a11y.trapFocus(this.siteNavigation, {
            elementToFocus: navigationButton,
          }),
          utils.enableTabbingOfChildren(selectors$19.navigation),
          $(selectors$19.navigation).attr("aria-hidden", !1),
          (this.promiseChain = this.promiseChain
            .then(this._promiseNavTransition.bind(this, !0))
            .then(
              this._promiseNavItemsTransition.bind(
                this,
                $(selectors$19.navAnimateElements, this.$container).toArray(),
                !0
              )
            )
            .then(
              function () {
                $(document).on(
                  "keyup" + this.namespace,
                  this._closeOnEscape.bind(this)
                ),
                  $(selectors$19.navigationButton)
                    .attr("aria-expanded", !0)
                    .off()
                    .one("click", this._toggleNavigationDisplay.bind(this));
              }.bind(this)
            ))),
        this.promiseChain.then(function () {
          Shopify.designMode &&
            $(document.body).addClass(classes$17.navigationOpenEditor);
        })
      );
    },
    hideNavigation: function () {
      var isOpen = $(document.body).hasClass(classes$17.navigationOpen);
      if (isOpen) {
        var $navElements = $(selectors$19.navAnimateElements, this.$container);
        a11y.removeTrapFocus(),
          utils.disableTabbingOfChildren(selectors$19.navigation),
          $(selectors$19.navigation).attr("aria-hidden", !0),
          Shopify.designMode &&
            ($(document.body).removeClass(classes$17.navigationOpenEditor),
            $navElements.addClass(classes$17.navigationEntranceActive)),
          (this.promiseChain = this.promiseChain
            .then(
              this._promiseNavItemsTransition.bind(
                this,
                $navElements.toArray().reverse(),
                !1
              )
            )
            .then(this._promiseNavTransition.bind(this, !1))
            .then(
              function () {
                (scrollHandler = !0),
                  $(document).off("keyup" + this.namespace),
                  $(selectors$19.navigationButton)
                    .off()
                    .one("click", this._toggleNavigationDisplay.bind(this))
                    .attr("aria-expanded", !1)
                    .focus();
              }.bind(this)
            ));
      }
      return this.promiseChain;
    },
    _toggleNavigationDisplay: function () {
      (navigationManuallyToggled = !0),
        $(document.body).hasClass(classes$17.navigationOpen)
          ? this.hideNavigation()
          : this.showNavigation();
    },
    _adjustNavigationPadding: function () {
      (this.headerHeight = this.$siteHeader.height()),
        $(selectors$19.navigation, this.$container).css({
          top: this.headerHeight + "px",
          "min-height": "calc(100vh - " + this.headerHeight + "px)",
          "max-height": "calc(100vh - " + this.headerHeight + "px)",
        });
    },
    _promiseNavTransition: function (active) {
      return (
        $(document.body)
          .addClass(classes$17.navigationTransitioning)
          .toggleClass(classes$17.navigationOpen, active),
        $(window).scrollTop(this.scrollTop),
        utils
          .promiseTransitionEnd($(selectors$19.navigation, this.$container))
          .then(function () {
            $(document.body).removeClass(classes$17.navigationTransitioning);
          })
      );
    },
    _promiseNavItemsTransition: function (elements, active) {
      return utils.mapPromiseSeries(elements, function (index, element) {
        var $element = $(element);
        return (
          $element.toggleClass(classes$17.navigationEntranceActive, active),
          utils.promiseTransitionEnd($element)
        );
      });
    },
    _closeOnEscape: function (evt) {
      evt.keyCode === 27 && this.hideNavigation();
    },
    _toggleNavigationSublinks: function (evt) {
      var $anchor = $(evt.currentTarget),
        $parent = $anchor.parent(),
        isExpanded = $anchor.attr("aria-expanded") === "true",
        $childSublinks = $parent.find(
          selectors$19.navigationExpandChildSublinks
        );
      $parent.toggleClass(classes$17.navigationHasSublinksCollapsed),
        $parent
          .siblings(selectors$19.navigationHasSublinks)
          .addClass(classes$17.navigationHasSublinksCollapsed)
          .children(selectors$19.navigationExpandSublinks)
          .attr("aria-expanded", !1),
        this._setMaxHeight(
          $parent.siblings(selectors$19.navigationHasSublinks),
          ""
        ),
        $childSublinks.length && this._updateSublinkMaxHeight($anchor),
        $anchor.attr("aria-expanded", !isExpanded),
        this._toggleSubNavigationElementHeight($anchor);
    },
    _updateSublinkMaxHeight: function ($anchor) {
      var isChildSublink = $anchor.hasClass(
        classes$17.navigationExpandChildSublinks
      );
      if (isChildSublink) {
        var $sublinkContainer = $anchor.closest(
            selectors$19.navigationSublinksContainer
          ),
          $childSublinks = $sublinkContainer.find(
            selectors$19.navigationHasSublinks
          ),
          maxHeight = $sublinkContainer.data("max-height");
        $childSublinks.each(function () {
          var $el = $(this);
          if (!$el.hasClass(classes$17.navigationHasSublinksCollapsed)) {
            var $childSublink = $el.find(selectors$19.navigationChildSublinks),
              $parent = $childSublink.parent();
            maxHeight += $parent.data("max-height");
          }
        }),
          $sublinkContainer.css("max-height", maxHeight);
      }
    },
    _setSublinksMaxHeight: function () {
      $(selectors$19.navigationSublinks, this.$container).each(function () {
        var $el = $(this),
          $parent = $el.parent(),
          sublinkHeight = $el.outerHeight();
        $parent
          .data("max-height", sublinkHeight)
          .css("max-height", sublinkHeight);
      });
    },
    _toggleSubNavigationElementHeight: function ($anchor) {
      var $currentListItem = $anchor.parent("li");
      if ($currentListItem.hasClass(classes$17.navigationHasSublinksCollapsed))
        this._setMaxHeight($currentListItem, "");
      else {
        if ($currentListItem.hasClass(selectors$19.navigationSublink)) {
          this._updateSublinkMaxHeight($currentListItem);
          return;
        }
        this._setMaxHeight($currentListItem, "none");
      }
    },
    _setMaxHeight: function (element, maxHeight) {
      element.css("max-height", maxHeight);
    },
  }),
    sections.register("list-collections-template", {
      onLoad: function () {
        this.extend(cardManager);
      },
    });
  var promiseGoogleMapsAPI,
    errors = {
      zeroResults: theme.strings.map && theme.strings.map.zeroResults,
      overQueryLimit: theme.strings.map && theme.strings.map.overQueryLimit,
      authError: theme.strings.map && theme.strings.map.authError,
      requestDenied: theme.strings.map && theme.strings.map.addressError,
      geocodeUnknownError: theme.strings.map && theme.strings.map.addressError,
      missingKey: theme.strings.map && theme.strings.map.addressError,
      apiLoadError: theme.strings.map && theme.strings.map.authError,
    };
  function errorMessage(status2) {
    var error;
    switch (status2) {
      case "ZERO_RESULTS":
        error = errors.zeroResults;
        break;
      case "OVER_QUERY_LIMIT":
        error = errors.overQueryLimit;
        break;
      case "REQUEST_DENIED":
        error = errors.requestDenied;
        break;
      case "UNKNOWN_ERROR":
        error = errors.geocodeUnknownError;
        break;
      default:
        error = errors.geocodeUnknownError;
    }
    return error;
  }
  var googleMaps = {
      promiseAPI: function (key) {
        return (
          (key = key || ""),
          typeof promiseGoogleMapsAPI > "u" &&
            (promiseGoogleMapsAPI = $.getScript(
              "https://maps.googleapis.com/maps/api/js?key=" + key
            )),
          promiseGoogleMapsAPI.then(function () {
            return $.Deferred(function (defer) {
              (!window.google || !window.google.maps) &&
                defer.reject(errors.apiLoadError),
                defer.resolve(window.google);
            });
          })
        );
      },
      promiseGeocode: function (address) {
        return this.promiseAPI().then(function (google) {
          return $.Deferred(function (defer) {
            var geocoder;
            (window.gm_authFailure = function () {
              defer.reject(errors.authError);
            }),
              (geocoder = new google.maps.Geocoder()),
              geocoder.geocode({ address }, function (results, status2) {
                status2 !== google.maps.GeocoderStatus.OK &&
                  defer.reject(errorMessage(status2)),
                  defer.resolve(results);
              });
          });
        });
      },
      promiseMap: function (config2) {
        return $.when(
          this.promiseAPI(config2.key),
          this.promiseGeocode(config2.address)
        ).then(function (google, results) {
          return $.Deferred(function (defer) {
            var map,
              center = results[0].geometry.location,
              mapOptions = $.extend(
                {},
                { zoom: 14, center, disableDefaultUI: !0 },
                config2
              );
            return (
              (window.gm_authFailure = function () {
                defer.reject(errors.authError);
              }),
              (map = new google.maps.Map(config2.container, mapOptions)),
              (map.centerMarker = new google.maps.Marker({
                map,
                position: map.getCenter(),
              })),
              google.maps.event.addDomListener(
                window,
                "resize",
                debounce(function () {
                  google.maps.event.trigger(map, "resize"),
                    map.setCenter(center);
                }, 250)
              ),
              defer.resolve(map)
            );
          });
        });
      },
    },
    selectors$20 = {
      map: ".map-section__container",
      mapError: ".map-section__error-message",
    },
    classes$18 = { mapError: "map-section--load-error" };
  sections.register("map", {
    onLoad: function () {
      if (
        ((this.$container = $(this.container)),
        (this.$map = $(selectors$20.map, this.$container)),
        (this.key = this.$map.data("api-key")),
        !(typeof this.key != "string" || this.key === ""))
      ) {
        var config2 = {
          key: this.key,
          container: this.$map[0],
          address: this.$map.data("address-setting"),
        };
        utils
          .promiseStylesheet()
          .then(function () {
            return googleMaps.promiseMap(config2);
          })
          .then(
            function (map) {
              this.map = map;
            }.bind(this)
          )
          .catch(
            function (error) {
              this.$container.addClass(classes$18.mapError),
                Shopify.designMode &&
                  $(selectors$20.mapError, this.$container)
                    .html(error)
                    .css("display", "inline-block");
            }.bind(this)
          );
      }
    },
  });
  var selectors$21 = {
      emailField: "#EmailField",
      inputGroup: ".input-group--underline",
      submitButton: ".btn--newsletter__submit",
      newsletterMessage: ".newsletter__message",
    },
    errors$1 = {
      blankError:
        theme.strings.newsletter && theme.strings.newsletter.blankError,
      invalidError:
        theme.strings.newsletter && theme.strings.newsletter.invalidError,
    };
  sections.register("newsletter", {
    onLoad: function () {
      $("html").hasClass("is-ios") &&
        Shopify.designMode &&
        $(selectors$21.inputGroup, this.$container).addClass("has-animated"),
        this.$container.on(
          "click",
          selectors$21.submitButton,
          this._checkEmail.bind(this)
        );
    },
    _checkEmail: function () {
      var emailFieldID =
          selectors$21.emailField + this.$container.data("section-id"),
        $emailField = $(emailFieldID, this.$container),
        $newsletterMessage = $(selectors$21.newsletterMessage, this.$container),
        errorMessage2,
        emailValue = $emailField[0].value,
        emailRegExp =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (
        (emailValue === ""
          ? (errorMessage2 = errors$1.blankError)
          : emailRegExp.test(emailValue) ||
            (errorMessage2 = errors$1.invalidError),
        typeof errorMessage2 < "u")
      )
        return (
          $newsletterMessage.html(
            '<p class="errors">' + errorMessage2 + "</p>"
          ),
          !1
        );
      $newsletterMessage.html("");
    },
  });
  var selectors$22 = {
      productRecommendationSlider: "[data-recommendations-slider]",
      productRecommendationSlides: "[data-recommendations-slide]",
      indicatorsWrapper: "[data-recommendations-indicators]",
      indicator: "[data-recommendations-indicator]",
      productRecommendationIndicatorIndex: function (index) {
        return '[data-product-recommendation-indicator-index="' + index + '"]';
      },
    },
    classes$19 = {
      indicatorActive: "product-recommendations__slide-indicator--active",
    },
    mobileMediaQuery = "(max-width: 749px)";
  sections.register("product-recommendations", {
    onLoad: function () {
      this.didShowRecommendations = !1;
      var baseUrl = this.$container.data("baseUrl"),
        productId = this.$container.data("productId"),
        recommendationsSectionUrl =
          baseUrl +
          "?section_id=product-recommendations&product_id=" +
          productId +
          "&limit=4";
      utils
        .promiseStylesheet()
        .then(function () {
          return $.get(recommendationsSectionUrl);
        })
        .then(
          function (section) {
            var recommendationsMarkup = $(section).html();
            recommendationsMarkup.trim() !== "" &&
              (this.$container.html(recommendationsMarkup),
              this._initProductRecommendations(),
              (this.didShowRecommendations = !0));
          }.bind(this)
        );
    },
    _initProductRecommendations: function () {
      (this.eventHandlers = {}),
        (this.mql = window.matchMedia(mobileMediaQuery)),
        this._setupEventHandlers(),
        this._mediaQueryHandler();
    },
    _setupEventHandlers: function () {
      (this.eventHandlers._mediaQueryHandler =
        this._mediaQueryHandler.bind(this)),
        (this.eventHandlers._updateIndicatorActiveState =
          this._updateIndicatorActiveState.bind(this)),
        this.mql.addListener(this.eventHandlers._mediaQueryHandler);
    },
    _mediaQueryHandler: function () {
      this.mql.matches
        ? this._initializeMobileSlider()
        : this._destroyMobileSlider();
    },
    _initializeMobileSlider: function () {
      (this.$slider =
        this.$slider ||
        this.$container.find(selectors$22.productRecommendationSlider)),
        (this.$slides =
          this.$slides ||
          this.$slider.find(selectors$22.productRecommendationSlides)),
        !(this.$slides.length < 2) &&
          ((this.$indicatorsWrapper =
            this.$indicatorsWrapper ||
            this.$container.find(selectors$22.indicatorsWrapper)),
          (this.$indicators =
            this.$indicators ||
            this.$indicatorsWrapper.find(selectors$22.indicator)),
          this.$slider.on(
            "scroll",
            { passive: !0 },
            this.eventHandlers._updateIndicatorActiveState
          ),
          this._updateIndicatorActiveState());
    },
    _destroyMobileSlider: function () {
      this.$slider && this.$slider.off("scroll");
    },
    _updateIndicatorActiveState: function () {
      this.$indicators.removeClass(classes$19.indicatorActive);
      var scrollLeft = this.$slider.scrollLeft(),
        numberOfSlides = this.$slides.length,
        slideWidth = this.$slider[0].scrollWidth / numberOfSlides,
        activeIndicatorIndex = Math.round(scrollLeft / slideWidth) + 1,
        $indicator = this.$container.find(
          selectors$22.productRecommendationIndicatorIndex(activeIndicatorIndex)
        );
      $indicator.addClass(classes$19.indicatorActive);
    },
    onUnload: function () {
      this.didShowRecommendations &&
        (this.mql.removeListener(this.eventHandlers._mediaQueryHandler),
        this._destroyMobileSlider());
    },
  });
  var classes$21 = {
      lazypreload: "lazypreload",
      showProductSlideshow: "product-slideshow--show",
      productSlideshowSelectActive: "product-slideshow__slide-select--active",
    },
    selectors$24 = {
      slider: "[data-product-slider]",
      productSlideshow: "[data-product-slideshow]",
      productSlideshowOpen: "[data-product-slideshow-open]",
      productSlideshowSlide: "[data-product-slideshow-slide]",
      productSlideshowImage: "[data-product-slideshow-image]",
      productSlideshowNext: "[data-product-slideshow-next]",
      productSlideshowSelect: "[data-product-slideshow-select]",
      productSlideshowPrevious: "[data-product-slideshow-previous]",
      productSlideshowClose: "[data-product-slideshow-close]",
      productMediaTypeVideo: "[data-product-media-type-video]",
      plyrAspectRatio: "[data-plyr-aspect-ratio]",
    },
    attributes$2 = { productMediaTypeModel: "data-product-media-type-model" },
    productSlideshow = {
      init: function () {
        (this.$productSlideshow = $(
          selectors$24.productSlideshow,
          this.$container
        )),
          (this.$slideshowSelect = $(selectors$24.productSlideshowSelect)),
          (this.translateDistance = 0),
          (this.dotSettings = { maxVisibleDots: 9, dotWidth: 16 }),
          this.extend(productModel),
          this.extend(productVideo),
          this.initModelViewers(this.$productSlideshow),
          this.initProductVideos(this.$productSlideshow),
          $(window).on(
            "resize",
            debounce(
              function () {
                this.adjustPlyrMaxWidth();
              }.bind(this),
              100
            )
          ),
          this.$productSlideshow.length !== 0 &&
            ($(selectors$24.productSlideshowOpen).on(
              "click",
              this._onImageClick.bind(this)
            ),
            this.$productSlideshow.appendTo(document.body),
            (this.slideCount = $(
              selectors$24.productSlideshowSlide,
              this.$productSlideshow
            ).length),
            this.slideCount &&
              ((this.slider = new Slider(
                $(selectors$24.slider, this.$productSlideshow)
              )),
              this.slider.$slides.on(
                "mediaSlideIsDraggable",
                function (event, isDraggable) {
                  this.slider.setIsDraggable(isDraggable);
                }.bind(this)
              )));
      },
      showSlideshow: function () {
        return (
          this.trigger("product_slideshow_show"),
          (this.$slideshowOpenFocus = $(document.activeElement)),
          $(
            selectors$24.productSlideshowImage,
            this.$productSlideshow
          ).addClass(classes$21.lazypreload),
          sections.getInstances("header-section").then(
            function (instances) {
              (instances[0].scrollHandler = !1),
                this._assignEventHandlers(),
                a11y$1.trapFocus({
                  $container: this.$productSlideshow,
                  namespace: "product-slideshow",
                }),
                this.$productSlideshow
                  .addClass(classes$21.showProductSlideshow)
                  .attr("aria-hidden", !1),
                this.adjustPlyrMaxWidth(),
                utils.disableScrollBody(),
                utils.enableTabbingOfChildren(this.$productSlideshow);
            }.bind(this)
          )
        );
      },
      hideSlideshow: function () {
        return (
          this.trigger("product_slideshow_hide"),
          sections.getInstances("header-section").then(
            function (instances) {
              (instances[0].scrollHandler = !0),
                this._removeEventHandlers(),
                a11y$1.removeTrapFocus({ namespace: "product-slideshow" }),
                utils.enableScrollBody(),
                utils.disableTabbingOfChildren(this.$productSlideshow),
                this.$productSlideshow
                  .removeClass(classes$21.showProductSlideshow)
                  .attr("aria-hidden", !0),
                this.$slideshowOpenFocus.focus(),
                this.slider.$currentSlide.trigger("mediaHidden"),
                this.updateShopifyXr();
            }.bind(this)
          )
        );
      },
      setSlide: function (id) {
        if (!(this.slideCount <= 1)) {
          var index = this._getSlideIndex(id);
          return (
            this.trigger("product_slideshow_set_slide", [index]),
            this.slider.setSlide(index)
          );
        }
      },
      adjustPlyrMaxWidth: function () {
        $(selectors$24.plyrAspectRatio).each(function () {
          var $aspectRatioContainer = $(this),
            aspectRatioValue = parseFloat(
              $aspectRatioContainer.data("plyr-aspect-ratio")
            ),
            parentHeight = $(
              $aspectRatioContainer.closest(selectors$24.productMediaTypeVideo)
            ).height(),
            maxWidth = parentHeight * aspectRatioValue;
          $aspectRatioContainer.css("max-width", maxWidth + "px");
        });
      },
      _onImageClick: function (evt) {
        evt.preventDefault();
        var id = $(evt.currentTarget).data("media-id");
        this.setSlide(id), this.showSlideshow(), this._triggerMediaVisible(id);
      },
      _triggerMediaVisible: function (id) {
        var $currentSlide = $(
          selectors$24.productSlideshowSlide,
          this.$productSlideshow
        ).filter('[data-media-id="' + id + '"]');
        $currentSlide && $currentSlide.trigger("mediaVisible");
      },
      _assignEventHandlers: function () {
        $(document).one("keyup.product-slideshow", this._onKeyup.bind(this)),
          this.$productSlideshow
            .on(
              "slidetransitionend",
              function (evt, data2) {
                this._setSlideIndicator(evt, data2);
                var currentMediaId = data2.$currentSlide.data("media-id");
                $(this.slider.$slides)
                  .filter(":not([data-media-id='" + currentMediaId + "'])")
                  .trigger("mediaHidden");
                var isCurrentSlideModel = data2.$currentSlide[0].hasAttribute(
                  attributes$2.productMediaTypeModel
                );
                isCurrentSlideModel && utils.isTouch()
                  ? (this.updateShopifyXr(this.id, currentMediaId),
                    this.slider.setIsDraggable(!0))
                  : isCurrentSlideModel
                  ? this.updateShopifyXr(this.id, currentMediaId)
                  : (this.updateShopifyXr(this.id),
                    this.slider.setIsDraggable(!0));
              }.bind(this)
            )
            .on(
              "click",
              selectors$24.productSlideshowSelect,
              this._setSlide.bind(this)
            )
            .on(
              "keyup",
              selectors$24.productSlideshowSelect,
              this._handleMediaFocus.bind(this)
            )
            .one(
              "click",
              selectors$24.productSlideshowClose,
              this.hideSlideshow.bind(this)
            )
            .one(
              "click",
              selectors$24.productSlideshowNext,
              this._nextSlide.bind(this)
            )
            .one(
              "click",
              selectors$24.productSlideshowPrevious,
              this._previousSlide.bind(this)
            );
      },
      _removeEventHandlers: function () {
        this.$productSlideshow.off(), $(document).off(".product-slideshow");
      },
      _getSlideIndex: function (id) {
        return $(selectors$24.productSlideshowSlide, this.$productSlideshow)
          .filter('[data-media-id="' + id + '"]')
          .index();
      },
      _handleMediaFocus: function (evt) {
        if (
          !(
            evt.keyCode !== utils.keyboardKeys.ENTER &&
            evt.keyCode !== utils.keyboardKeys.SPACE
          )
        ) {
          var slideIndex = $(evt.currentTarget).index(),
            $slide = $(this.slider.$slides[slideIndex]),
            $plyrOrModel = $slide.find("model-viewer, .plyr");
          $plyrOrModel.length ? $plyrOrModel.first().focus() : $slide.focus();
        }
      },
      _setSlide: function (evt) {
        var $navButton = $(evt.target),
          index = $navButton.index();
        this.trigger("product_slideshow_set_slide", [index]),
          this.slider.setSlide(index);
      },
      _nextSlide: function () {
        return (
          this.trigger("product_slideshow_next"),
          this.trigger("product_slideshow_set_slide", [
            this.slider.$nextSlide.index(),
          ]),
          this.slider.nextSlide().then(
            function () {
              this.$productSlideshow.one(
                "click",
                selectors$24.productSlideshowNext,
                this._nextSlide.bind(this)
              );
            }.bind(this)
          )
        );
      },
      _previousSlide: function () {
        return (
          this.trigger("product_slideshow_previous"),
          this.trigger("product_slideshow_set_slide", [
            this.slider.$previousSlide.index(),
          ]),
          this.slider.previousSlide().then(
            function () {
              this.$productSlideshow.one(
                "click",
                selectors$24.productSlideshowPrevious,
                this._previousSlide.bind(this)
              );
            }.bind(this)
          )
        );
      },
      _setSlideIndicator: function (evt, data2) {
        var index = data2.$currentSlide.index();
        $(selectors$24.productSlideshowSelect, this.$productSlideshow)
          .eq(index)
          .addClass(classes$21.productSlideshowSelectActive)
          .siblings()
          .removeClass(classes$21.productSlideshowSelectActive),
          this.translateDots(index);
      },
      translateDots: function (index) {
        var settings2 = this.dotSettings;
        if (!(this.slideCount <= settings2.maxVisibleDots)) {
          var maxTranslateDistance =
            (this.slideCount - settings2.maxVisibleDots) * settings2.dotWidth;
          if (index >= settings2.maxVisibleDots - 1) {
            var calculatedTranslateDistance =
              (index + 2 - settings2.maxVisibleDots) * settings2.dotWidth;
            (calculatedTranslateDistance =
              maxTranslateDistance < calculatedTranslateDistance
                ? maxTranslateDistance
                : calculatedTranslateDistance),
              (this.translateDistance = -calculatedTranslateDistance);
          } else this.translateDistance = 0;
          this.$slideshowSelect.css(
            "transform",
            "translateX(" + this.translateDistance + "px)"
          );
        }
      },
      _onKeyup: function (evt) {
        var promiseTransition = $.Deferred().resolve(),
          shouldPreventSlide = this.slider.shouldPreventSlide(
            evt.target,
            [".plyr", ".shopify-model-viewer-ui"],
            this.slideCount
          );
        switch (evt.keyCode) {
          case 37:
            if (shouldPreventSlide) break;
            promiseTransition = this.slider.previousSlide();
            break;
          case 39:
            if (shouldPreventSlide) break;
            promiseTransition = this.slider.nextSlide();
            break;
          case 27:
            this.hideSlideshow(), (promiseTransition = $.Deferred().reject());
            break;
        }
        promiseTransition.then(
          function () {
            $(document).one("keyup", this._onKeyup.bind(this));
          }.bind(this)
        );
      },
    },
    selectors$23 = {
      productFormWrapper: ".product__form-wrapper",
      productDescription: ".product__description",
    },
    classes$20 = {
      productFormFixed: "product__form-wrapper--fixed",
      productFormBottom: "product__form-wrapper--bottom",
    },
    formStickyTop = 80;
  sections.register("product-template", {
    onLoad: function () {
      (this.coverPosition = "top"),
        this.extend(productSlideshow),
        this.extend(socialSharing),
        this.extend(productDisplay),
        this.window().on("scroll", this._setFormPosition.bind(this)),
        this.window().on(
          "resize",
          debounce(this._callResizeFunctions.bind(this), 500)
        ),
        this.on("variant_add_to_cart", this._updateMeasurements.bind(this)),
        this.on("variant_change", this._updateHistoryState.bind(this)),
        this.document().on(
          "drawer_open_start",
          this._handleFixedSideImage.bind(this)
        ),
        this.document().on(
          "drawer_close_done",
          this._resetFixedSideImage.bind(this)
        ),
        utils.promiseStylesheet().then(
          function () {
            this._updateMeasurements();
          }.bind(this)
        );
    },
    _callResizeFunctions: function () {
      this._updateMeasurements(), this._formatVariantSelectors();
    },
    _handleFixedSideImage: function () {
      if (this.coverPosition === "fixed") {
        var scrollTop = $(window).scrollTop(),
          translate = scrollTop - this.fixedTop + 2 * formStickyTop + 28;
        $(selectors$23.productFormWrapper, this.$container).css({
          transform: "translateY(" + translate + "px)",
          position: "absolute",
        });
      }
    },
    _resetFixedSideImage: function () {
      this.coverPosition === "fixed" &&
        $(selectors$23.productFormWrapper, this.$container).css({
          transform: "",
          position: "",
        });
    },
    _updateHistoryState: function (event, instance, product2, variant) {
      var image = $("#variant-images [data-id=" + variant.id + "]").data(
        "image"
      );
      if (
        ($("#section-cta__product-image-main").prop("src", image),
        !!history.replaceState)
      ) {
        var newurl =
          window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          "?variant=" +
          variant.id;
        window.history.replaceState({ path: newurl }, "", newurl);
      }
    },
    _setFormPosition: function () {
      if (!(utils.isMobile() || !this.enableSticky)) {
        var scrollTop = $(window).scrollTop();
        requestAnimationFrame(
          function () {
            scrollTop > this.fixedTop
              ? scrollTop > this.fixedBottom
                ? ((this.coverPosition = "bottom"),
                  $(selectors$23.productFormWrapper)
                    .css("width", this.formWidth)
                    .removeClass(classes$20.productFormFixed)
                    .addClass(classes$20.productFormBottom))
                : ((this.coverPosition = "fixed"),
                  $(selectors$23.productFormWrapper)
                    .css("width", this.formWidth)
                    .addClass(classes$20.productFormFixed)
                    .removeClass(classes$20.productFormBottom))
              : ((this.coverPosition = "top"),
                $(selectors$23.productFormWrapper)
                  .css("width", "")
                  .removeClass(classes$20.productFormFixed)
                  .removeClass(classes$20.productFormBottom));
          }.bind(this)
        );
      }
    },
    _updateMeasurements: function () {
      var $formWrapper = $(selectors$23.productFormWrapper),
        descriptionHeight = $(selectors$23.productDescription).outerHeight(!0),
        formHeight = $formWrapper.height();
      (this.enableSticky = descriptionHeight > formHeight),
        this.enableSticky &&
          ((this.fixedTop = $formWrapper.parent().offset().top - formStickyTop),
          (this.fixedBottom = this.fixedTop + descriptionHeight - formHeight),
          (this.formWidth = $formWrapper.parent().width()),
          this._setFormPosition());
    },
  });
  var selectors$25 = { slider: ".quotes-slider", slide: ".quotes-slide" },
    classes$22 = { visible: "quotes-slide--visible" };
  sections.register("quotes-section", {
    onLoad: function () {
      (this.$container = $(this.container)),
        (this.$slider = $(selectors$25.slider, this.$container)),
        (this.totalSlides = this.$slider.data("count")),
        (this.speed = this.$slider.data("speed")),
        (this.currentSlide = 0),
        this.$slider.find(selectors$25.slide).length > 1 && this._startSlider();
    },
    _startSlider: function () {
      this.interval = setInterval(
        function () {
          this.currentSlide + 1 >= this.totalSlides
            ? (this.currentSlide = 0)
            : this.currentSlide++,
            this._showSlide(selectors$25.slide + "--" + this.currentSlide);
        }.bind(this),
        this.speed
      );
    },
    _showSlide: function (slide) {
      this.$slider
        .find(selectors$25.slide)
        .removeClass(classes$22.visible)
        .end()
        .find(slide)
        .addClass(classes$22.visible);
    },
    onBlockSelect: function (evt) {
      clearInterval(this.interval);
      var $selectedSlide = this.$container.find(
        selectors$25.slide + "--" + evt.detail.blockId
      );
      this._showSlide($selectedSlide);
    },
    onBlockDeselect: function () {
      this._startSlider();
    },
  }),
    sections.register("search-template", {
      onLoad: function () {
        this.extend(cardManager);
      },
    });
  var promiseVimeoAPI,
    vimeo = {
      promiseAPI: function () {
        return (
          promiseVimeoAPI ||
            (promiseVimeoAPI = $.Deferred(function (defer) {
              var tag = document.createElement("script");
              (tag.src = "https://player.vimeo.com/api/player.js"),
                (tag.onload = tag.onreadystatechange =
                  function () {
                    (!this.readyState || this.readyState === "complete") &&
                      defer.resolve();
                  });
              var firstScriptTag = document.getElementsByTagName("script")[0];
              firstScriptTag.parentNode.insertBefore(tag, firstScriptTag),
                setTimeout(function () {
                  defer.reject(
                    "Request for Vimeo API timed out after 30 seconds."
                  );
                }, 3e4);
            })),
          promiseVimeoAPI
        );
      },
      promisePlayer: function (id, options) {
        return this.promiseAPI().then(function () {
          return $.Deferred(function (defer) {
            typeof window.Vimeo > "u" &&
              defer.reject(
                "We're sorry, something went wrong. The Vimeo API has not loaded correctly."
              );
            var player = new window.Vimeo.Player(id, options);
            setTimeout(function () {
              defer.reject(
                "Request for Vimeo player has timed out after 30 seconds."
              );
            }, 3e4),
              player.ready().then(function () {
                defer.resolve(player);
              });
          });
        });
      },
    },
    selectors$27 = {
      buttons: ".slideshow__buttons",
      button: ".slideshow__button",
      pauseButton: "[data-pause-button]",
      label: ".slideshow__button-label",
      cta: ".slideshow__button-cta--desktop",
      ctaText: ".slideshow__heading-cta-text",
      slide: ".slideshow__slide",
      slideshow: ".slideshow",
      video: ".slideshow__video",
    },
    classes$24 = {
      centredCta: "slideshow--center-cta",
      buttonActive: "slideshow__button--active",
      headingCtaActive: "slideshow__heading-cta-text--active",
      headingCtaTransitioning: "slideshow__heading-cta-text--transitioning",
      linkActive: "slideshow__button--link",
      slideActive: "slideshow__slide--active",
      slideActiveTransitioning: "slideshow__slide--transitioning",
      videoLoaded: "slideshow__video--loaded",
      videoPaused: "slideshow__video--paused",
      paused: "is-paused",
    },
    config = { easeIntensity: 10 },
    slideshowDesktop = {
      initDesktopSlideshow: function () {
        this.trigger("slideshow_desktop_init_start"),
          (this.$slideshow = $(selectors$27.slideshow, this.$container)),
          (this.$slide = $(selectors$27.slide, this.$container)),
          (this.$buttons = $(selectors$27.buttons, this.$container)),
          (this.$button = $(selectors$27.button, this.$container)),
          (this.desktopSlideshow = !0),
          (this.isAnimating = !1),
          (this.currentDesktopSlide = 0),
          (this.totalSlides = this.$buttons.data("count")),
          (this.players = []),
          (this.desktopSlideshowNamespace = ".desktopSlideshow"),
          (this.isPostInitialized = !1),
          this.on(
            "mouseover" + this.desktopSlideshowNamespace,
            this._onHoverSlideshow.bind(this)
          ),
          this.on(
            "mousemove" + this.desktopSlideshowNamespace,
            this._mouseMoveButtons.bind(this)
          ),
          this.on(
            "mouseleave" + this.desktopSlideshowNamespace,
            this._resetButtonsPosition.bind(this)
          ),
          this.on(
            "keydown" + this.desktopSlideshowNamespace,
            this._onTabButtons.bind(this)
          ),
          this.on(
            "click" + this.desktopSlideshowNamespace,
            selectors$27.pauseButton,
            this._onPauseButton.bind(this)
          ),
          this.on(
            "click" + this.desktopSlideshowNamespace,
            selectors$27.label,
            this._onClickButton.bind(this)
          ),
          this.on(
            "keydown" + this.desktopSlideshowNamespace,
            this._addKeyBindingsDesktop.bind(this)
          ),
          this.window().on(
            "resize" + this.desktopSlideshowNamespace,
            this._setButtonWrapperValues.bind(this)
          ),
          utils.promiseStylesheet().then(
            function () {
              this._setButtonWrapperValues(),
                this._setSlideDesktop(0),
                this.$container.hasClass(classes$24.centredCta) &&
                  this._setButtonStatus(0),
                this.trigger("slideshow_desktop_init_done");
            }.bind(this)
          );
      },
      destroyDesktopSlideshow: function () {
        this.trigger("slideshow_desktop_destroy"),
          (this.desktopSlideshow = !1),
          this.off(this.desktopSlideshowNamespace),
          this.window().off(this.desktopSlideshowNamespace),
          this._setButtonsTranslateX(0);
        for (var key in this.players) {
          if (!this.players.hasOwnProperty(key)) return;
          var player = this.players[key];
          typeof player.destroy == "function"
            ? player.destroy()
            : typeof player.unload == "function" && player.unload();
        }
        this.players = [];
      },
      _onHoverSlideshow: function () {
        this._animateButtonFrame();
      },
      _mouseMoveButtons: function (evt) {
        this.totalSlides <= 3 ||
          ((this.mousePosition = evt.pageX - this.centerOfButtonsWrapper),
          this.isAnimating ||
            ((this.isAnimating = !0), this._animateButtonFrame()));
      },
      _resetButtonsPosition: function () {
        this.mousePosition = 0;
      },
      _onTabButtons: function (evt) {
        if (evt.which === utils.keyboardKeys.TAB) {
          var $nextButton;
          if (
            (evt.shiftKey
              ? ($nextButton = $(evt.target).closest(this.$button).prev())
              : ($nextButton = $(evt.target).closest(this.$button).next()),
            !!$nextButton.length)
          ) {
            var division = $(window).width() / this.totalSlides,
              buttonIndex = $nextButton.index();
            (this.mousePosition = division * buttonIndex - $nextButton.width()),
              this._animateButtonFrame();
          }
        }
      },
      _onPauseButton: function (evt) {
        var $currentSlide = this.$slide.eq(this.currentDesktopSlide),
          $pauseButton = $(evt.target),
          isPaused = $pauseButton.hasClass(classes$24.paused),
          blockId = this.$video.attr("data-block-id");
        $pauseButton.toggleClass(classes$24.paused, !isPaused).attr({
          "aria-label": isPaused
            ? $pauseButton.data("label-pause")
            : $pauseButton.data("label-play"),
          "aria-pressed": !isPaused,
        }),
          this.players[blockId] &&
            (isPaused
              ? this.players[blockId].playVideo()
              : this.players[blockId].pauseVideo()),
          $currentSlide.toggleClass(classes$24.videoPaused);
      },
      _onClickButton: function (evt) {
        var $buttonClicked = $(evt.target).closest(selectors$27.button);
        if (!$buttonClicked.hasClass(classes$24.buttonActive)) {
          var index = $buttonClicked.index();
          this._setSlideDesktop(index),
            $buttonClicked.hasClass(classes$24.buttonActive) ||
              this._setButtonStatus(index);
        }
      },
      _setButtonStatus: function (index) {
        var $button = this.$button.eq(index),
          $buttonText = $button.find(selectors$27.ctaText);
        this.$button
          .removeClass(classes$24.buttonActive)
          .find(selectors$27.label)
          .attr("aria-expanded", !1),
          $button
            .addClass(classes$24.buttonActive)
            .find(selectors$27.label)
            .attr("aria-expanded", !0),
          this.isPostInitialized
            ? $button.focus()
            : (this.isPostInitialized = !0),
          this.$buttons
            .find(selectors$27.ctaText)
            .empty()
            .attr("aria-hidden", !0)
            .removeClass(classes$24.headingCtaActive)
            .removeAttr("style"),
          $buttonText.parent().is("a") && this._showButtonContent($buttonText),
          this.$button.find(selectors$27.cta).attr("tabindex", "-1"),
          $button.hasClass(classes$24.linkActive) &&
            $button.find(selectors$27.cta).attr("tabindex", "0");
      },
      _animateButtonFrame: function () {
        var deltaPosition = this.mousePosition - this.xPosition,
          widthDifferenceRatio =
            this.buttonsInnerWidth / this.buttonsWrapperWidth - 1;
        if (Math.abs(deltaPosition) < 1) {
          this.isAnimating = !1;
          return;
        }
        (this.xPosition += deltaPosition / config.easeIntensity),
          this._setButtonsTranslateX(-(this.xPosition * widthDifferenceRatio)),
          requestAnimationFrame(this._animateButtonFrame.bind(this));
      },
      _showButtonContent: function ($buttonText) {
        var buttonText = $buttonText.data("button-text");
        $buttonText.html(buttonText).attr("aria-hidden", !1),
          (!$buttonText.attr("data-new-width") ||
            !$buttonText.attr("data-new-height")) &&
            ($buttonText.attr("data-new-width", $buttonText.outerWidth()),
            $buttonText.attr("data-new-height", $buttonText.outerHeight()));
        var newButtonContentWidth = $buttonText.attr("data-new-width"),
          newButtonContentHeight = $buttonText.attr("data-new-height");
        $buttonText.empty(),
          requestAnimationFrame(function () {
            $buttonText
              .css({
                minHeight: newButtonContentHeight + "px",
                minWidth: newButtonContentWidth + "px",
              })
              .addClass(classes$24.headingCtaTransitioning);
          }),
          utils.promiseTransitionEnd($buttonText).then(function () {
            $buttonText
              .html(buttonText)
              .removeClass(classes$24.headingCtaTransitioning)
              .addClass(classes$24.headingCtaActive);
          });
      },
      _setButtonsTranslateX: function (xPosition) {
        this.$buttons.css({
          transform: "translate3d(" + xPosition + "px, 0, 0)",
        });
      },
      _addKeyBindingsDesktop: function (evt) {
        evt.which === utils.keyboardKeys.LEFTARROW
          ? this._previousSlideDesktop()
          : evt.which === utils.keyboardKeys.RIGHTARROW &&
            this._nextSlideDesktop();
      },
      _previousSlideDesktop: function () {
        this.currentDesktopSlide !== 0 &&
          this._setSlideDesktop(this.currentDesktopSlide - 1);
      },
      _nextSlideDesktop: function () {
        this.currentDesktopSlide !== this.totalSlides - 1 &&
          this._setSlideDesktop(this.currentDesktopSlide + 1);
      },
      _setSlideDesktop: function (slideIndex) {
        var $currentSlide = this.$slide.eq(this.currentDesktopSlide),
          $nextSlide = this.$slide.eq(slideIndex),
          $video = $nextSlide.find(selectors$27.video);
        $video.length && this._loadVideo($video, $nextSlide),
          this.currentDesktopSlide !== slideIndex &&
            ($nextSlide
              .addClass(classes$24.slideActive)
              .attr("aria-hidden", !1),
            $currentSlide.addClass(classes$24.slideActiveTransitioning),
            utils.promiseTransitionEnd($nextSlide).then(function () {
              $currentSlide
                .removeClass(classes$24.slideActive)
                .removeClass(classes$24.slideActiveTransitioning)
                .attr("aria-hidden", !0);
            }),
            this._setButtonStatus(slideIndex),
            (this.currentDesktopSlide = slideIndex),
            this.trigger("slideshow_set_slide", [slideIndex]),
            this.currentDesktopSlide - 1 >= 0 &&
              this.trigger("slideshow_previous_slide", [slideIndex - 1]),
            this.currentDesktopSlide + 1 < this.totalSlides &&
              this.trigger("slideshow_next_slide", [slideIndex + 1]));
      },
      _loadVideo: function ($video, $slide) {
        return (
          (this.$video = $video),
          this.trigger("slideshow_video_load", [$video[0]]),
          this._promiseVideo().then(
            function () {
              $slide.addClass(classes$24.videoLoaded),
                $slide.find(selectors$27.pauseButton).prop("disabled", !1),
                this.trigger("slideshow_video_loaded", [$video[0]]);
            }.bind(this)
          )
        );
      },
      _promiseVideo: function () {
        var playerType = this.$video.attr("data-video-type"),
          promiseVideoPlayer;
        return (
          playerType === "youtube"
            ? ((promiseVideoPlayer = this._loadYoutubePlayer()),
              this.$video.attr("tabindex", "-1"))
            : playerType === "vimeo" &&
              ((promiseVideoPlayer = this._loadVimeoPlayer()),
              this.$video.find("iframe").attr("tabindex", "-1")),
          promiseVideoPlayer
        );
      },
      _loadYoutubePlayer: function () {
        var blockId = this.$video.attr("data-block-id"),
          videoId = this.$video.attr("data-video-id");
        return youtube
          .promisePlayer(this.$video[0], {
            videoId,
            ratio: 16 / 9,
            playerVars: {
              iv_load_policy: 3,
              modestbranding: 1,
              autoplay: 0,
              controls: 0,
              showinfo: 0,
              wmode: "opaque",
              branding: 0,
              autohide: 0,
              rel: 0,
            },
            events: {
              onStateChange: function (evt) {
                evt.data === 0 && this.players[blockId].seekTo(0);
              }.bind(this),
            },
          })
          .then(
            function (player) {
              return (
                (this.players[blockId] = player),
                player.playVideo().mute(),
                $(player.a).css("visibility", "visible"),
                $.Deferred(function (defer) {
                  player.addEventListener("onStateChange", function (evt) {
                    evt.data === 1 && defer.resolve();
                  });
                })
              );
            }.bind(this)
          );
      },
      _loadVimeoPlayer: function () {
        var blockId = this.$video.attr("data-block-id"),
          videoId = this.$video.attr("data-video-id");
        return vimeo
          .promisePlayer(this.$video[0], {
            id: videoId,
            loop: !0,
            playbar: !1,
            background: !0,
          })
          .then(
            function (player) {
              return (
                (this.players[blockId] = player),
                player.play(),
                player.setVolume(0),
                $.Deferred(function (defer) {
                  player.on("loaded", function () {
                    defer.resolve();
                  });
                })
              );
            }.bind(this)
          );
      },
      _setButtonWrapperValues: function () {
        (this.mousePosition = 0),
          (this.xPosition = 0),
          (this.buttonsWrapperWidth = this.$container.outerWidth()),
          (this.buttonsInnerWidth =
            this.$button.first().width() * this.totalSlides),
          (this.centerOfButtonsWrapper = this.buttonsWrapperWidth / 2),
          this.$button
            .find(selectors$27.ctaText)
            .removeAttr(
              "style data-previous-width data-previous-height data-new-width data-new-height"
            ),
          this._setButtonsTranslateX(0);
      },
    },
    selectors$28 = {
      button: ".slideshow__button",
      buttons: ".slideshow__buttons",
      ctaMultipleSlides: ".slideshow__button-cta--multiple",
      ctaSingleSlide: ".slideshow__button-cta-single",
      label: ".slideshow__button-label",
      mobileTextContainer: ".slideshow__text-container-mobile",
      mobileTextContent: ".slideshow__text-content-mobile",
      navigationButtons: "[data-slider-navigation]",
      nextButton: "[data-slider-navigation-next]",
      previousButton: "[data-slider-navigation-previous]",
      slide: ".slideshow__slide",
      slideshow: ".slideshow",
      indicatorDots: ".slideshow__indicator",
    },
    classes$25 = {
      buttonActive: "slideshow__button--active",
      dotActive: "slideshow__indicator--active",
      linkActive: "slideshow__button--link",
      slideActive: "slideshow__slide--active",
      slideActiveTransitioning: "slideshow__slide--transitioning",
      navigationNoFocus: "slideshow__navigation-item--no-focus",
    },
    slideshowMobile = {
      initMobileSlideshow: function () {
        this.trigger("slideshow_mobile_init_start"),
          (this.$slideshow = $(selectors$28.slideshow, this.$container)),
          (this.$buttons = $(selectors$28.buttons, this.$container)),
          (this.$button = $(selectors$28.button, this.$container)),
          (this.$navigationButtons = $(
            selectors$28.navigationButtons,
            this.$container
          )),
          (this.$ctaMultipleSlides = $(
            selectors$28.ctaMultipleSlides,
            this.$container
          )),
          (this.$ctaSingleSlide = $(
            selectors$28.ctaSingleSlide,
            this.$container
          )),
          (this.$indicatorDots = $(
            selectors$28.indicatorDots,
            this.$container
          )),
          (this.$mobileTextContainer = $(
            selectors$28.mobileTextContainer,
            this.$container
          )),
          (this.$mobileTextContent = $(
            selectors$28.mobileTextContent,
            this.$container
          )),
          (this.mobileSlideshow = !0),
          (this.currentMobileSlide = 0),
          (this.totalSlides = this.$buttons.data("count")),
          (this.xPosition = 0),
          (this.mobileSlideshowNamespace = ".mobileSlideshow"),
          $("html").hasClass("is-ios") &&
            Shopify.designMode &&
            this.$slideshow.css("height", "-=60px"),
          this.on(
            "click keyup" + this.mobileSlideshowNamespace,
            selectors$28.indicatorDots,
            this._onClickIndicatorDot.bind(this)
          ),
          this.on(
            "click keyup" + this.mobileSlideshowNamespace,
            selectors$28.previousButton,
            this._previousSlideMobile.bind(this)
          ),
          this.on(
            "click keyup" + this.mobileSlideshowNamespace,
            selectors$28.nextButton,
            this._nextSlideMobile.bind(this)
          ),
          this.on(
            "keydown" + this.mobileSlideshowNamespace,
            this._addKeyBindingsMobile.bind(this)
          ),
          this.totalSlides > 1 &&
            ((this.hammertime = new Hammer2(this.$container[0])),
            this.hammertime
              .on("swipeleft", this._nextSlideMobile.bind(this))
              .on("swiperight", this._previousSlideMobile.bind(this))),
          this.$button.first().addClass(classes$25.buttonActive),
          utils.promiseStylesheet().then(
            function () {
              this._setSlideMobile(0),
                this._setMobileText(0),
                this._setSlideshowA11y(),
                this.trigger("slideshow_mobile_init_done");
            }.bind(this)
          );
      },
      destroyMobileSlideshow: function () {
        this.trigger("slideshow_mobile_destroy"),
          (this.mobileSlideshow = !1),
          this.$container.off(this.mobileSlideshowNamespace),
          this.totalSlides > 1 && this.hammertime.destroy();
      },
      _onClickIndicatorDot: function (evt) {
        var $indicatorDot = $(evt.target),
          index = $indicatorDot.data("slide-index");
        evt.preventDefault(),
          !(
            evt.type === "keyup" &&
            !(
              evt.keyCode === utils.keyboardKeys.ENTER ||
              evt.keyCode === utils.keyboardKeys.SPACE
            )
          ) &&
            (this._setSlideMobile(index),
            (evt.type === "keyup" || evt.detail === 0) &&
              this.$slideshow.focus());
      },
      _addKeyBindingsMobile: function (evt) {
        evt.which === utils.keyboardKeys.LEFTARROW
          ? this._previousSlideMobile(evt)
          : evt.which === utils.keyboardKeys.RIGHTARROW &&
            this._nextSlideMobile(evt);
      },
      _previousSlideMobile: function (evt) {
        evt.type === "click" &&
          $(evt.target).addClass(classes$25.navigationNoFocus),
          !(
            (evt.type === "keyup" &&
              !(
                evt.keyCode === utils.keyboardKeys.ENTER ||
                evt.keyCode === utils.keyboardKeys.SPACE
              )) ||
            this.currentMobileSlide === 0
          ) && this._setSlideMobile(this.currentMobileSlide - 1);
      },
      _nextSlideMobile: function (evt) {
        evt.type === "click" &&
          $(evt.target).addClass(classes$25.navigationNoFocus),
          !(
            (evt.type === "keyup" &&
              !(
                evt.keyCode === utils.keyboardKeys.ENTER ||
                evt.keyCode === utils.keyboardKeys.SPACE
              )) ||
            this.currentMobileSlide === this.totalSlides - 1
          ) && this._setSlideMobile(this.currentMobileSlide + 1);
      },
      _setSlideMobile: function (slideIndex) {
        this.currentMobileSlide !== slideIndex &&
          ((this.xPosition = slideIndex * 50),
          this.$buttons.css({
            transform: "translate3d(-" + this.xPosition + "%, 0, 0)",
          }),
          this._setActiveStates(slideIndex),
          this._setSlideA11y(slideIndex),
          this._setMobileText(slideIndex),
          (this.currentMobileSlide = slideIndex),
          this.trigger("slideshow_set_slide", [slideIndex]),
          this.$navigationButtons.attr("disabled", !1),
          this.currentMobileSlide === 0 &&
            this.$navigationButtons
              .filter(selectors$28.previousButton)
              .attr("disabled", !0),
          this.currentMobileSlide === this.totalSlides - 1 &&
            this.$navigationButtons
              .not(selectors$28.previousButton)
              .attr("disabled", !0),
          this.currentMobileSlide - 1 >= 0 &&
            this.trigger("slideshow_previous_slide", [slideIndex - 1]),
          this.currentMobileSlide + 1 < this.totalSlides &&
            this.trigger("slideshow_next_slide", [slideIndex + 1]));
      },
      _setActiveStates: function (slideIndex) {
        (this.$slide = this.$slide || $(selectors$28.slide, this.$container)),
          (this.$button =
            this.$button || $(selectors$28.button, this.$container)),
          (this.$dot =
            this.$dot || $(selectors$28.indicatorDots, this.$container));
        var $currentSlide = this.$slide.eq(this.currentMobileSlide),
          $nextSlide = this.$slide.eq(slideIndex);
        $nextSlide.addClass(classes$25.slideActive).attr("aria-hidden", !1),
          $currentSlide.addClass(classes$25.slideActiveTransitioning),
          utils.promiseTransitionEnd($nextSlide).then(function () {
            $currentSlide
              .removeClass(classes$25.slideActive)
              .removeClass(classes$25.slideActiveTransitioning)
              .attr("aria-hidden", !0);
          }),
          this.$button.removeClass(classes$25.buttonActive),
          this.$button.eq(slideIndex).addClass(classes$25.buttonActive),
          this.$dot.removeClass(classes$25.dotActive),
          this.$dot.eq(slideIndex).addClass(classes$25.dotActive);
      },
      _setSlideshowA11y: function () {
        (this.$labels = this.$labels || this.$button.find(selectors$28.label)),
          (this.$ctaSingleSlide =
            this.$ctaSingleSlide ||
            this.$button.find(selectors$28.ctaSingleSlide)),
          this.$ctaSingleSlide.attr("tabindex", "0"),
          this.$labels.attr("tabindex", "-1"),
          this._setSlideA11y(0),
          $.each(
            this.$indicatorDots,
            function (index, indicatorDot) {
              $(indicatorDot).attr({ "aria-controls": "Slide" + index });
            }.bind(this)
          );
      },
      _setSlideA11y: function (slideIndex) {
        var $button = this.$button.eq(slideIndex);
        (this.$ctasMultipleSlides =
          this.$ctasMultipleSlides ||
          this.$button.find(selectors$28.ctaMultipleSlides)),
          this.$ctasMultipleSlides &&
            (this.$ctasMultipleSlides.attr("tabindex", "-1"),
            $button.hasClass(classes$25.linkActive) &&
              this.$ctasMultipleSlides.eq(slideIndex).attr("tabindex", "0")),
          $.each(
            this.$indicatorDots,
            function (index, indicatorDot) {
              $(indicatorDot).attr({
                "aria-label": this._slideLabel(slideIndex, index),
                "aria-current": slideIndex === index,
              });
            }.bind(this)
          );
      },
      _setMobileText: function (slideIndex) {
        var $currentTextContent = this.$mobileTextContent.eq(slideIndex);
        if (
          ((this.$ctaSingleSlide =
            this.$ctaSingleSlide ||
            this.$button.find(selectors$28.ctaSingleSlide)),
          this.$ctaSingleSlide.length)
        ) {
          var paddingAdjustment =
            (this.$ctaSingleSlide.outerHeight() - 50) / 2 + 40;
          this.$mobileTextContent.css("padding-top", paddingAdjustment + "px");
        }
        this.$mobileTextContent.hide(), $currentTextContent.show();
      },
      _slideLabel: function (activeSlideIndex, currentIndex) {
        var label =
          activeSlideIndex === currentIndex
            ? theme.strings.slideshow.activeSlideA11yString
            : theme.strings.slideshow.loadSlideA11yString;
        return label.replace("[slide_number]", currentIndex + 1);
      },
    },
    selectors$26 = { button: ".slideshow__button", slide: ".slideshow__slide" },
    classes$23 = {
      buttonActive: "slideshow__button--active",
      slideActive: "slideshow__slide--active",
    };
  sections.register("slideshow-section", {
    onLoad: function () {
      this.extend(slideshowDesktop),
        this.extend(slideshowMobile),
        this.$container.on(
          "focusin" + this.namespace,
          this._onFocusIn.bind(this)
        ),
        this.$container.on(
          "focusout" + this.namespace,
          this._onFocusOut.bind(this)
        ),
        this._toggleViewState(),
        this.window().on("resize", this._toggleViewState.bind(this));
    },
    onUnload: function () {
      this._destroyDesktopState(), this._destroyMobileState();
    },
    onBlockSelect: function (evt) {
      utils.promiseStylesheet().then(
        function () {
          var index = $(evt.target).index();
          this.mobileViewEnabled
            ? this._setSlideMobile(index)
            : this._setSlideDesktop(index);
        }.bind(this)
      );
    },
    _toggleViewState: function () {
      var windowWidth = $(window).innerWidth(),
        enableMobileView,
        enableDesktopView;
      typeof this.mobileViewEnabled > "u"
        ? ((enableMobileView = windowWidth < theme.mediaQuerySmall),
          (enableDesktopView = windowWidth >= theme.mediaQuerySmall))
        : ((enableMobileView =
            windowWidth < theme.mediaQuerySmall && !this.mobileViewEnabled),
          (enableDesktopView =
            windowWidth >= theme.mediaQuerySmall && this.mobileViewEnabled)),
        enableMobileView &&
          ((this.mobileViewEnabled = !0),
          this._destroyDesktopState(),
          this._enableMobileState()),
        enableDesktopView &&
          ((this.mobileViewEnabled = !1),
          this._destroyMobileState(),
          this._enableDesktopState());
    },
    _enableDesktopState: function () {
      this.initDesktopSlideshow();
    },
    _destroyDesktopState: function () {
      this.desktopSlideshow &&
        (this.destroyDesktopSlideshow(), this._resetSlideshowValues());
    },
    _enableMobileState: function () {
      this.initMobileSlideshow();
    },
    _destroyMobileState: function () {
      this.mobileSlideshow &&
        (this.destroyMobileSlideshow(), this._resetSlideshowValues());
    },
    _resetSlideshowValues: function () {
      $(selectors$26.slide)
        .removeClass(classes$23.slideActive)
        .first()
        .addClass(classes$23.slideActive),
        $(selectors$26.button)
          .removeClass(classes$23.buttonActive)
          .first()
          .addClass(classes$23.buttonActive);
    },
    _onFocusIn: function (evt) {
      (this.$container.has(evt.target).length &&
        this.$slideshow.attr("aria-live") === "polite") ||
        this.$slideshow.attr("aria-live", "polite");
    },
    _onFocusOut: function (evt) {
      this.$container.has(evt.relatedTarget).length ||
        this.$slideshow.removeAttr("aria-live");
    },
  });
  var selectors$29 = {
      loadPlayerButton: ".video-section__load-player-button",
      closePlayerButton: ".video-section__player-close",
      playerContainer: ".video-section__player",
      cover: ".video-section__cover",
      errorMessage: ".video-section__error",
      bodyOverlay: ".video-section__body-overlay",
    },
    classes$26 = {
      playerLoading: "video-section--loading",
      playerLoaded: "video-section--loaded",
      playerError: "video-section--error",
      animateButton: "animated pulse",
    };
  sections.register("video-section", {
    onLoad: function () {
      (this.$container = $(this.container)),
        this.$container
          .on(
            "click",
            selectors$29.loadPlayerButton,
            this._loadPlayer.bind(this)
          )
          .on(
            "click",
            selectors$29.closePlayerButton,
            this._closePlayer.bind(this)
          )
          .on("click", selectors$29.bodyOverlay, this._closePlayer.bind(this));
    },
    _loadPlayer: function () {
      var $container = this.$container,
        $loadButton = $(selectors$29.loadPlayerButton, $container),
        $playerContainer = $(selectors$29.playerContainer, $container),
        playerType = this.$container.attr("data-video-type"),
        promiseVideoPlayer;
      return (
        $loadButton.addClass(classes$26.animateButton),
        this._scrollToPlayer($container),
        playerType === "youtube"
          ? (promiseVideoPlayer = this._loadYoutubePlayer($playerContainer[0]))
          : playerType === "vimeo" &&
            (promiseVideoPlayer = this._loadVimeoPlayer($playerContainer[0])),
        promiseVideoPlayer
          .then(this._onPlayerLoadReady.bind(this))
          .catch(this._onPlayerLoadError.bind(this))
          .always(function () {
            $loadButton.removeClass(classes$26.animateButton);
          })
      );
    },
    _scrollToPlayer: function (container) {
      var containerTop = container.offset().top,
        offset = ($(window).height() - container.height()) / 2;
      $("html, body").animate(
        { scrollTop: containerTop - Math.max(offset, 0) },
        400
      );
    },
    _loadYoutubePlayer: function (container) {
      return youtube
        .promisePlayer(container, {
          videoId: this.$container.attr("data-video-id"),
          ratio: 16 / 9,
          playerVars: { modestbranding: 1, autoplay: 1, showinfo: 0, rel: 0 },
        })
        .then(
          function (player) {
            this.player = player;
          }.bind(this)
        );
    },
    _loadVimeoPlayer: function (container) {
      return vimeo
        .promisePlayer(container, { id: this.$container.attr("data-video-id") })
        .then(
          function (player) {
            (this.player = player), this.player.play();
          }.bind(this)
        );
    },
    _onPlayerLoadReady: function () {
      $(selectors$29.closePlayerButton, this.$container).show().focus(),
        $(selectors$29.cover, this.$container)
          .prepareTransition()
          .addClass(classes$26.playerLoaded),
        this.$container.addClass(classes$26.playerLoaded),
        this._setScrollPositionValues(),
        $(document)
          .one("keyup" + this.namespace, this._closeOnEscape.bind(this))
          .on("scroll" + this.namespace, this._onScroll.bind(this)),
        $(window).on(
          "resize" + this.namespace,
          this._setScrollPositionValues.bind(this)
        );
    },
    _onPlayerLoadError: function (err) {
      this.$container.addClass(classes$26.playerError),
        $(selectors$29.errorMessage, this.$container).text(err);
    },
    _closeOnEscape: function (evt) {
      evt.keyCode === 27 &&
        (this._closePlayer(),
        $(selectors$29.loadPlayerButton, this.$container).focus());
    },
    _onScroll: function () {
      var scrollTop = $(window).scrollTop();
      (scrollTop > this.videoTop + 0.25 * this.videoHeight ||
        scrollTop + this.windowHeight <
          this.videoBottom - 0.25 * this.videoHeight) &&
        requestAnimationFrame(this._closePlayer.bind(this));
    },
    _setScrollPositionValues: function () {
      (this.videoHeight = this.$container.outerHeight(!0)),
        (this.videoTop = this.$container.offset().top),
        (this.videoBottom = this.videoTop + this.videoHeight),
        (this.windowHeight = $(window).innerHeight());
    },
    _closePlayer: function () {
      $(selectors$29.cover, this.$container)
        .prepareTransition()
        .removeClass(classes$26.playerLoaded),
        this.$container.removeClass(classes$26.playerLoaded),
        $(selectors$29.closePlayerButton, this.$container).hide(),
        typeof this.player.destroy == "function"
          ? this.player.destroy()
          : typeof this.player.unload == "function" && this.player.unload(),
        $(document).off(this.namespace),
        $(window).off(this.namespace);
    },
  }),
    (window.theme.templates = templates),
    (window.theme.sections = sections),
    $(document).ready(function () {
      templates.load("*"), sections.load("*");
    });
  function getCookie(name) {
    let matches = document.cookie.match(
      new RegExp(
        "(?:^|; )" +
          name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
          "=([^;]*)"
      )
    );
    return matches ? decodeURIComponent(matches[1]) : void 0;
  }
  $(document).ready(function () {
    if ($("#g-recaptcha").length && getCookie("worldmap_g_id")) {
      var target = $('input[name="return_to"]');
      target.length !== 0
        ? target.val("/pages/worldmap-completed")
        : $("main").on("DOMSubtreeModified propertychange", function (e) {
            if ($(e.target).children('input[name="return_to"]').length !== 0) {
              var target2 = $('input[name="return_to"]');
              target2.val("/pages/worldmap-completed");
            }
          });
    }
    if ($("#worldmap-complete").length !== 0) {
      var id = getCookie("worldmap_g_id"),
        email = getCookie("worldmap_g_email");
      if (id) {
        var headers = {
            accept: "application/json",
            "Content-Type": "application/x-www-form-urlencoded",
          },
          params = new URLSearchParams();
        params.append("id", id),
          email && params.append("email", email),
          axios
            .post("https://generator.holicc.jp/screenshot/mail", params, {
              headers,
            })
            .then(function (result) {
              (document.cookie = "worldmap_g_id=; path=/; max-age=-1"),
                (document.cookie = "worldmap_g_email=; path=/; max-age=-1");
            });
      }
    }
  }),
    $("#loadmail-button").click(function () {
      var email = $('input[name="customer[email]"]')[0].value;

      // validation
      var reg =
        /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/;
      if (!reg.test(email)) {
        alert("メールアドレスが不正です");
        return;
      } else {
        $("#loadmail-button").prop("disabled", true);
        var headers = {
          accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded",
        };
        var params = new URLSearchParams();
        axios
          .get("https://generator.holicc.jp/find/" + email, params, {
            headers: headers,
          })
          .then(function (result) {
            const resultEmail = result.data.email;
            const resultCountries = result.data.contories;
            const resultColor = result.data.color;
            if (!resultCountries) {
              $("#loadmail-button").prop("disabled", false);
              $("#load-error")[0].textContent = "登録データがありませんでした";
              return;
            } else {
              $("#load-error")[0].textContent = "";
            }
            var color = $('input[name="color"]')[0];
            color.value = resultColor;
            resultCountries.forEach(function (countryCode) {
              var countries = $('input[name="countries"]');
              for (let i = 0; i < countries.length; i++) {
                if (countries[i].value == countryCode) {
                  countries[i].checked = true;
                }
                var containers = document.getElementsByClassName(
                  "worldmap__sublinks-container"
                );
                // HTMLCollectionをループで処理
                for (var index = 0; index < containers.length; index++) {
                  var container = containers[index];
                  var inputList = container.querySelectorAll(
                    'input[name="countries"]'
                  );
                  for (let input of inputList) {
                    if (input.value === countryCode) {
                      container.style.display = "block";
                    }
                  }
                }
              }
            });
            $("#loadmail-button").prop("disabled", false);
          });
      }
    });

  $("#generate-button").click(function () {
    var email = $('input[name="customer[email]"]')[0].value;
    var subscribe = $('input[name="subscribe"]')[0].value;

    // validation
    var reg =
      /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/;
    if (!reg.test(email)) {
      alert("メールアドレスが不正です");
      return;
    } else {
      $("#register-button").prop("disabled", true);
      var headers = {
        accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
      };
      var params = new URLSearchParams();
      var selectedCountries = [];
      var countries = $('input[name="countries"]');
      for (let i = 0; i < countries.length; i++) {
        if (countries[i].checked) {
          selectedCountries.push(countries[i].value);
        }
      }
      var color = $('input[name="color"]')[0].value;
      params.append("email", email);
      params.append("cc", selectedCountries.join(","));
      params.append("color", color);
      params.append("subscribe", subscribe);
      axios
        .post("https://generator.holicc.jp/screenshot", params, {
          headers: headers,
        })
        .then(function (result) {
          if (result.data.error === "exist user") {
            alert("すでに会員のためログインをおねがいします。");
            $("#register-button").prop("disabled", false);
          } else {
            document.cookie = "worldmap_g_id=" + result.data.id + "; path=/";
            document.cookie = "worldmap_g_email=" + email + "; path=/";
            location.href = "/pages/worldmap-completed";
          }
        });
    }
  });
  const expandLinks = document.getElementsByClassName(
    "worldmap__expand-sublinks"
  );
  if (expandLinks.length != 0)
    for (var i = 0; i < expandLinks.length; i++)
      document
        .getElementsByClassName("worldmap__expand-sublinks")
        [i].addEventListener("click", function () {
          $(this).next().slideToggle();
        });
})(
  jQuery,
  _.omit,
  _.find,
  _.throttle,
  Shopify.theme.a11y,
  _.remove,
  _.filter,
  _.fill,
  _.debounce,
  morphdom,
  _.defaultTo,
  _.findIndex,
  _.isArray,
  Hammer
);
//# sourceMappingURL=/s/files/1/0474/9662/6339/t/93/assets/theme.js.map?v=1731324869
